const $f9da35ca885f15a0$export$9655df7bb03b83fe = document.querySelector('.getVerse');
const $f9da35ca885f15a0$export$c61c2cc86422adfb = document.querySelector('.verse div');
const $f9da35ca885f15a0$export$32e8bae6af6667e9 = document.querySelector('.hiddenVerseHolder');
const $f9da35ca885f15a0$export$19732eed08316548 = document.querySelector("#email");
const $f9da35ca885f15a0$export$e317c825d4537eb2 = document.querySelector("#email-error"); //export const loader = document.querySelector('.loader');


function $71b08f0ec20f8cf3$export$19e5ffab0d0b9126(arr, not) {
    const random = Math.floor(Math.random() * arr.length);
    const indexVerseFR = random % 2 === 0 ? random : random - 1;
    const indexVerseEN = indexVerseFR + 1;
    console.log("FR index  =  " + indexVerseFR);
    console.log("EN index  =  " + indexVerseEN);
    console.log(`Total verses: ${arr.length / 2}`);
    const verseFR = arr[indexVerseFR];
    const verseEN = arr[indexVerseEN];
    if (verseFR === not) {
        console.log('Ahh we used that one last time, look again');
        return $71b08f0ec20f8cf3$export$19e5ffab0d0b9126(arr, not);
    }
    return {
        verseFR: verseFR,
        verseEN: verseEN
    };
}


const $56f685a6bdc4117b$var$versesBucket = [
    `<p>1 Samuel 10:6 (S21)</p> L'Esprit de l'\xc9ternel viendra sur toi ; tu proph\xe9tiseras avec eux et tu deviendras un autre homme.`,
    `<p>1 Samuel 10:6 (NKJV) </p> Then the Spirit of the LORD will come upon you, and you will prophesy with them and be turned into another man.`,
    `<p>N\xe9h\xe9mie 9:20 (S21)</p> Tu leur as donn\xe9 ton bon Esprit pour les rendre sages, tu ne les as pas priv\xe9s de ta manne et tu as continu\xe9 \xe0 leur fournir de l'eau pour \xe9tancher leur soif.`,
    `<p>Nehemiah 9:20 (NKJV) </p> You also gave Your good Spirit to instruct them, And did not withhold Your manna from their mouth, And gave them water for their thirst.`,
    `<p>Proverbes 1:23 (BDS)</p> \xc9coutez mes avertissements, voici : je r\xe9pandrai sur vous mon Esprit et je vous ferai conna\xeetre mes paroles.`,
    `<p>Proverbs 1:23 (NKJV) </p> Turn at my rebuke; Surely I will pour out my spirit on you; I will make my words known to you.`,
    `<p>Psaume 143:10 (S21)</p> Enseigne-moi \xe0 faire ta volont\xe9, car c\u{2019}est toi qui es mon Dieu. Que ton bon Esprit me conduise sur le terrain de la droiture !`,
    `<p>Psalm 143:10 (NKJV) </p> Teach me to do Your will, For You are my God; Your Spirit is good. Lead me in the land of uprightness.`,
    `<p>\xc9sa\xefe 11:2 (LSG)</p> L\u{2019}Esprit de l\u{2019}\xc9ternel reposera sur lui: Esprit de sagesse et d\u{2019}intelligence, Esprit de conseil et de force, Esprit de connaissance et de crainte de l\u{2019}\xc9ternel.`,
    `<p>Isaiah 11:2 (NKJV) </p> The Spirit of the LORD shall rest upon Him, The Spirit of wisdom and understanding, The Spirit of counsel and might, The Spirit of knowledge and of the fear of the LORD.`,
    `<p>\xc9sa\xefe 32:15 (S21)</p> jusqu'\xe0 ce que l'Esprit soit d\xe9vers\xe9 d'en haut sur nous. Alors le d\xe9sert se transformera en verger et le verger sera assimil\xe9 \xe0 une for\xeat.`,
    `<p>Isaiah 32:15 (NKJV) </p> Until the Spirit is poured upon us from on high, And the wilderness becomes a fruitful field, And the fruitful field is counted as a forest.`,
    `<p>\xc9sa\xefe 34:16 (BDS)</p> Consultez et lisez le livre de l\u{2019}\xc9ternel : aucun des membres de son peuple, ne manquera, aucun d\u{2019}eux n\u{2019}aura \xe0 chercher en vain son compagnon, car l\u{2019}\xc9ternel, de sa bouche, en a donn\xe9 l\u{2019}ordre, c\u{2019}est son Esprit qui les a rassembl\xe9es.`,
    `<p>Isaiah 34:16 (NKJV) </p> "Search from the book of the LORD, and read: Not one of these shall fail; Not one shall lack her mate. For My mouth has commanded it, and His Spirit has gathered them.`,
    `<p>\xc9sa\xefe 42:1 (S21)</p> Voici mon serviteur, celui que je soutiendrai, celui que j\u{2019}ai choisi et qui a toute mon approbation. J'ai mis mon Esprit sur lui ; il r\xe9v\xe9lera le droit aux nations.`,
    `<p>Isaiah 42:1 (NKJV) </p> "Behold! My Servant whom I uphold, My Elect One in whom My soul delights! I have put My Spirit upon Him; He will bring forth justice to the Gentiles.`,
    `<p>\xc9sa\xefe 44:3 (S21)</p> En effet, je verserai de l\u{2019}eau sur la terre qui a soif et des ruisseaux sur le terrain sec ; je d\xe9verserai mon Esprit sur ta descendance et ma b\xe9n\xe9diction sur tes rejetons.`,
    `<p>Isaiah 44:3 (NKJV) </p> For I will pour water on him who is thirsty, And floods on the dry ground; I will pour My Spirit on your descendants, And My blessing on your offspring;`,
    `<p>\xc9sa\xefe 59:21 (S21)</p> Quant \xe0 moi, telle sera mon alliance avec eux, dit l'\xc9ternel : mon Esprit, qui repose sur toi, et mes paroles, celles que j'ai mises dans ta bouche, ne quitteront pas ta bouche, ni celle de tes enfants, ni celle de tes petits-enfants, dit l'\xc9ternel, d\xe8s maintenant et pour toujours.`,
    `<p>Isaiah 59:21 (NKJV) </p> "As for Me," says the LORD, "this is My covenant with them: My Spirit who is upon you, and My words which I have put in your mouth, shall not depart from your mouth, nor from the mouth of your descendants, nor from the mouth of your descendants' descendants," says the LORD, "from this time and forevermore."`,
    `<p>\xc9sa\xefe 61:1-3 (LSG)</p> L\u{2019}Esprit du Seigneur, l\u{2019}\xc9ternel, est sur moi, Car l\u{2019}\xc9ternel m\u{2019}a oint pour porter de bonnes nouvelles aux malheureux; Il m\u{2019}a envoy\xe9 pour gu\xe9rir ceux qui ont le c\u{153}ur bris\xe9, Pour proclamer aux captifs la libert\xe9, Et aux prisonniers la d\xe9livrance; Pour publier une ann\xe9e de gr\xe2ce de l\u{2019}\xc9ternel, Et un jour de vengeance de notre Dieu; Pour consoler tous les afflig\xe9s; Pour accorder aux afflig\xe9s de Sion, Pour leur donner un diad\xe8me au lieu de la cendre, Une huile de joie au lieu du deuil, Un v\xeatement de louange au lieu d\u{2019}un esprit abattu, Afin qu\u{2019}on les appelle des t\xe9r\xe9binthes de la justice, Une plantation de l\u{2019}\xc9ternel, pour servir \xe0 sa gloire.`,
    `<p>Isaiah 61:1-3 (NKJV) </p> "The Spirit of the Lord GOD is upon Me, Because the LORD has anointed Me To preach good tidings to the poor; He has sent Me to heal the brokenhearted, To proclaim liberty to the captives, And the opening of the prison to those who are bound; To proclaim the acceptable year of the LORD, And the day of vengeance of our God; To comfort all who mourn, To console those who mourn in Zion, To give them beauty for ashes, The oil of joy for mourning, The garment of praise for the spirit of heaviness; That they may be called trees of righteousness, The planting of the LORD, that He may be glorified."`,
    `<p>\xc9sa\xefe 63:14 (S21)</p> Comme \xe0 un troupeau qui gagne la vall\xe9e, l'Esprit de l'Eternel leur a accord\xe9 le repos. \xbb Voil\xe0 comment tu conduisais ton peuple, te faisant ainsi une r\xe9putation splendide.`,
    `<p>Isaiah 63:14 (NKJV) </p> As a beast goes down into the valley, And the Spirit of the LORD causes him to rest, So You lead Your people, To make Yourself a glorious name.`,
    `<p>\xc9z\xe9chiel 36:26-27 (S21)</p> Je vous donnerai un c\u{153}ur nouveau et je mettrai en vous un esprit nouveau. Je retirerai de votre corps le c\u{153}ur de pierre et je vous donnerai un c\u{153}ur de chair. C\u{2019}est mon Esprit que je mettrai en vous. Ainsi, je vous ferai suivre mes prescriptions, garder et respecter mes r\xe8gles.`,
    `<p>Ezekiel 36:26-27 (NKJV) </p> I will give you a new heart and put a new spirit within you; I will take the heart of stone out of your flesh and give you a heart of flesh. I will put My Spirit within you and cause you to walk in My statutes, and you will keep My judgments and do them.`,
    `<p>\xc9z\xe9chiel 37:7-10 (S21)</p> J\u{2019}ai proph\xe9tis\xe9 conform\xe9ment \xe0 l'ordre que j'avais re\xe7u. Alors que je proph\xe9tisais, il y a eu un bruit : un mouvement s\u{2019}est produit et les os se sont rapproch\xe9s les uns des autres. J\u{2019}ai regard\xe9 et j\u{2019}ai vu qu\u{2019}il leur apparaissait des nerfs ; la chair a commenc\xe9 \xe0 pousser et la peau les a recouverts en dernier, mais il n'y avait pas d'esprit en eux. Il m\u{2019}a dit : \xab Proph\xe9tise \xe0 l\u{2019}intention de l'Esprit, proph\xe9tise, fils de l\u{2019}homme ! Tu annonceras \xe0 l'Esprit : \u{2018}Voici ce que dit le Seigneur, l'\xc9ternel : Esprit, viens des quatre vents, souffle sur ces morts et qu'ils revivent !\u{2019} \xbb J\u{2019}ai proph\xe9tis\xe9 conform\xe9ment \xe0 l'ordre qu'il m'avait donn\xe9. Alors l'Esprit est entr\xe9 en eux et ils ont repris vie, puis ils se sont tenus sur leurs pieds. C'\xe9tait une arm\xe9e nombreuse, tr\xe8s nombreuse.`,
    `<p>Ezekiel 37:7-10 (NKJV) </p> So I prophesied as I was commanded; and as I prophesied, there was a noise, and suddenly a rattling; and the bones came together, bone to bone. Indeed, as I looked, the sinews and the flesh came upon them, and the skin covered them over; but there was no breath in them. Also He said to me, "Prophesy to the breath, prophesy, son of man, and say to the breath, "Thus says the Lord GOD: "Come from the four winds, O breath, and breathe on these slain, that they may live.""' So I prophesied as He commanded me, and breath came into them, and they lived, and stood upon their feet, an exceedingly great army.`,
    `<p>\xc9z\xe9chiel 37:11-14 (S21)</p> Il m\u{2019}a dit : \xab Fils de l\u{2019}homme, ces ossements, c'est toute la communaut\xe9 d'Isra\xebl. Ils affirment : \u{2018}Nos os sont dess\xe9ch\xe9s, notre esp\xe9rance est d\xe9truite, nous sommes an\xe9antis !\u{2019} C\u{2019}est pourquoi, proph\xe9tise ! Tu leur annonceras : \u{2018}Voici ce que dit le Seigneur, l'\xc9ternel : Je vais ouvrir vos tombes et je vous en ferai sortir, vous qui \xeates mon peuple, et je vous ram\xe8nerai sur le territoire d'Isra\xebl. Vous reconna\xeetrez que je suis l'\xc9ternel, lorsque j'ouvrirai vos tombes et vous en ferai sortir, vous qui \xeates mon peuple. Je mettrai mon Esprit en vous, vous vivrez et je vous donnerai du repos sur votre territoire. Vous reconna\xeetrez alors que moi, l'\xc9ternel, j'ai parl\xe9 et agi, d\xe9clare l'\xc9ternel.\u{2019} \xbb`,
    `<p>Ezekiel 37:11-14 (NKJV) </p> Then He said to me, "Son of man, these bones are the whole house of Israel. They indeed say, "Our bones are dry, our hope is lost, and we ourselves are cut off!' Therefore prophesy and say to them, "Thus says the Lord GOD: "Behold, O My people, I will open your graves and cause you to come up from your graves, and bring you into the land of Israel. Then you shall know that I am the LORD, when I have opened your graves, O My people, and brought you up from your graves. I will put My Spirit in you, and you shall live, and I will place you in your own land. Then you shall know that I, the LORD, have spoken it and performed it," says the LORD."'`,
    `<p>\xc9z\xe9chiel 39:29 (S21)</p> Je ne me d\xe9tournerai plus d\u{2019}eux, parce que je d\xe9verserai mon Esprit sur la communaut\xe9 d'Isra\xebl, d\xe9clare le Seigneur, l'\xc9ternel. \xbb`,
    `<p>Ezekiel 39:29 (NKJV) </p> And I will not hide My face from them anymore; for I shall have poured out My Spirit on the house of Israel,' says the Lord GOD."`,
    `<p>Jo\xebl 2:28-29 (LSG)</p> Apr\xe8s cela, je r\xe9pandrai mon Esprit sur toute chair; Vos fils et vos filles proph\xe9tiseront, Vos vieillards auront des songes, Et vos jeunes gens des visions. M\xeame sur les serviteurs et sur les servantes, Dans ces jours-l\xe0, je r\xe9pandrai mon Esprit.`,
    `<p>Joel 2:28-29 (NKJV) </p> "And it shall come to pass afterward That I will pour out My Spirit on all flesh; Your sons and your daughters shall prophesy, Your old men shall dream dreams, Your young men shall see visions. And also on My menservants and on My maidservants I will pour out My Spirit in those days.`,
    `<p>Mich\xe9e 3:8 (S21)</p> Mais moi, je suis rempli de force, gr\xe2ce \xe0 l'Esprit de l'\xc9ternel, je suis rempli de justice et de courage pour faire conna\xeetre \xe0 Jacob sa r\xe9volte et \xe0 Isra\xebl son p\xe9ch\xe9.`,
    `<p>Micah 3:8 (NKJV) </p> But truly I am full of power by the Spirit of the LORD, And of justice and might, To declare to Jacob his transgression And to Israel his sin.`,
    `<p>Zacharie 12:10 (S21)</p> Alors je d\xe9verserai sur la famille de David et sur les habitants de J\xe9rusalem un esprit de gr\xe2ce et de supplication, et ils tourneront les regards vers moi, celui qu'ils ont transperc\xe9. Ils pleureront sur lui comme on pleure sur un fils unique, ils pleureront am\xe8rement sur lui comme on pleure sur un premier-n\xe9.`,
    `<p>Zechariah 12:10 (NKJV) </p> "And I will pour on the house of David and on the inhabitants of Jerusalem the Spirit of grace and supplication; then they will look on Me whom they pierced. Yes, they will mourn for Him as one mourns for his only son, and grieve for Him as one grieves for a firstborn.`,
    `<p>Matthieu 12:18 (S21)</p> Voici mon serviteur que j'ai choisi, mon bien-aim\xe9 qui a toute mon approbation. Je mettrai mon Esprit sur lui, et il annoncera la justice aux nations.`,
    `<p>Matthew 12:18 (NKJV) </p> "Behold! My Servant whom I have chosen, My Beloved in whom My soul is well pleased! I will put My Spirit upon Him, And He will declare justice to the Gentiles.`,
    `<p>Jean 6:63 (S21)</p> C'est l'Esprit qui fait vivre, l\u{2019}homme n\u{2019}arrive \xe0 rien. Les paroles que je vous dis sont Esprit et vie,`,
    `<p>John 6:63 (NKJV) </p> It is the Spirit who gives life; the flesh profits nothing. The words that I speak to you are spirit, and they are life.`,
    `<p>Jean 7:37-39 (S21)</p> Le dernier jour, le grand jour de la f\xeate, J\xe9sus, debout, s'\xe9cria : \xab Si quelqu'un a soif, qu'il vienne \xe0 moi et qu'il boive. Celui qui croit en moi, des fleuves d'eau vive couleront de lui, comme l\u{2019}a dit l'\xc9criture. \xbb Il dit cela \xe0 propos de l'Esprit que devaient recevoir ceux qui croiraient en lui. En effet, l'Esprit [saint] n'avait pas encore \xe9t\xe9 donn\xe9 parce que J\xe9sus n'avait pas encore \xe9t\xe9 \xe9lev\xe9 dans sa gloire.`,
    `<p>John 7:37-39 (NKJV) </p> On the last day, that great day of the feast, Jesus stood and cried out, saying, "If anyone thirsts, let him come to Me and drink. He who believes in Me, as the Scripture has said, out of his heart will flow rivers of living water." But this He spoke concerning the Spirit, whom those believing in Him would receive; for the Holy Spirit was not yet given, because Jesus was not yet glorified.`,
    `<p>Jean 14:26 (S21)</p> mais le d\xe9fenseur, l'Esprit saint que le P\xe8re enverra en mon nom, vous enseignera toutes choses et vous rappellera tout ce que je vous ai dit.`,
    `<p>John 14:26 (NKJV) </p> But the Helper, the Holy Spirit, whom the Father will send in My name, He will teach you all things, and bring to your remembrance all things that I said to you.`,
    `<p>Jean 15:26 (S21)</p> \xbb Quand sera venu le d\xe9fenseur que je vous enverrai de la part du P\xe8re, l'Esprit de la v\xe9rit\xe9 qui vient du P\xe8re, il rendra t\xe9moignage de moi.`,
    `<p>John 15:26 (NKJV) </p> "But when the Helper comes, whom I shall send to you from the Father, the Spirit of truth who proceeds from the Father, He will testify of Me.`,
    `<p>Jean 16:13 (S21)</p> Quand le d\xe9fenseur sera venu, l'Esprit de la v\xe9rit\xe9, il vous conduira dans toute la v\xe9rit\xe9, car il ne parlera pas de lui-m\xeame, mais il dira tout ce qu'il aura entendu et vous annoncera les choses \xe0 venir.`,
    `<p>John 16:13 (NKJV) </p> However, when He, the Spirit of truth, has come, He will guide you into all truth; for He will not speak on His own authority, but whatever He hears He will speak; and He will tell you things to come.`,
    `<p>Jean 20:21-23 (S21)</p> J\xe9sus leur dit de nouveau : \xab Que la paix soit avec vous ! Tout comme le P\xe8re m'a envoy\xe9, moi aussi je vous envoie. \xbb Apr\xe8s ces paroles, il souffla sur eux et leur dit : \xab Recevez le Saint-Esprit ! Ceux \xe0 qui vous pardonnerez les p\xe9ch\xe9s, ils leur seront pardonn\xe9s ; ceux \xe0 qui vous les retiendrez, ils leur seront retenus. \xbb`,
    `<p>John 20:21-23 (NKJV) </p> So Jesus said to them again, "Peace to you! As the Father has sent Me, I also send you." And when He had said this, He breathed on them, and said to them, "Receive the Holy Spirit. If you forgive the sins of any, they are forgiven them; if you retain the sins of any, they are retained."`,
    `<p>Actes 1:8 (S21)</p> Mais vous recevrez une puissance lorsque le Saint-Esprit viendra sur vous, et vous serez mes t\xe9moins \xe0 J\xe9rusalem, dans toute la Jud\xe9e, dans la Samarie et jusqu'aux extr\xe9mit\xe9s de la terre. \xbb`,
    `<p>Acts 1:8 (NKJV) </p> But you shall receive power when the Holy Spirit has come upon you; and you shall be witnesses to Me in Jerusalem, and in all Judea and Samaria, and to the end of the earth."`,
    `<p>Actes 2:38 (LSG)</p> Pierre leur dit: Repentez-vous, et que chacun de vous soit baptis\xe9 au nom de J\xe9sus-Christ, pour le pardon de vos p\xe9ch\xe9s; et vous recevrez le don du Saint-Esprit.`,
    `<p>Acts 2:38 (NKJV) </p> Then Peter said to them, "Repent, and let every one of you be baptized in the name of Jesus Christ for the remission of sins; and you shall receive the gift of the Holy Spirit.`,
    `<p>Actes 4:31 (S21)</p> Quand ils eurent pri\xe9, l'endroit o\xf9 ils \xe9taient rassembl\xe9s trembla ; ils furent tous remplis du Saint-Esprit et ils annon\xe7aient la parole de Dieu avec assurance.`,
    `<p>Acts 4:31 (NKJV) </p> And when they had prayed, the place where they were assembled together was shaken; and they were all filled with the Holy Spirit, and they spoke the word of God with boldness.`,
    `<p>Actes 5:32 (S21)</p> Nous sommes t\xe9moins de ces \xe9v\xe9nements, de m\xeame que le Saint-Esprit que Dieu a donn\xe9 \xe0 ceux qui lui ob\xe9issent. \xbb`,
    `<p>Acts 5:32 (NKJV) </p> And we are His witnesses to these things, and so also is the Holy Spirit whom God has given to those who obey Him."`,
    `<p>Actes 8:29 (S21)</p> L'Esprit dit \xe0 Philippe : \xab Avance et approche-toi de ce char. \xbb`,
    `<p>Acts 8:29 (NKJV) </p> Then the Spirit said to Philip, "Go near and overtake this chariot."`,
    `<p>Actes 9:17 (S21)</p> Ananias partit. Une fois entr\xe9 dans la maison, il posa les mains sur Saul en disant : \xab Saul mon fr\xe8re, le Seigneur, [le J\xe9sus] qui t'est apparu sur le chemin par lequel tu venais, m'a envoy\xe9 pour que tu retrouves la vue et que tu sois rempli du Saint-Esprit. \xbb`,
    `<p>Acts 9:17 (NKJV) </p> And Ananias went his way and entered the house; and laying his hands on him he said, "Brother Saul, the Lord Jesus, who appeared to you on the road as you came, has sent me that you may receive your sight and be filled with the Holy Spirit."`,
    `<p>Actes 9:31 (S21)</p> L'\xc9glise \xe9tait en paix dans toute la Jud\xe9e, la Galil\xe9e et la Samarie ; elle s'\xe9difiait, marchait dans la crainte du Seigneur et grandissait gr\xe2ce \xe0 l'aide du Saint-Esprit.`,
    `<p>Acts 9:31 (NKJV) </p> Then the churches throughout all Judea, Galilee, and Samaria had peace and were edified. And walking in the fear of the Lord and in the comfort of the Holy Spirit, they were multiplied.`,
    `<p>Actes 10:38 (S21)</p> Vous savez comment Dieu a d\xe9vers\xe9 une onction de Saint-Esprit et de puissance sur J\xe9sus de Nazareth, qui allait de lieu en lieu en faisant le bien et en gu\xe9rissant tous ceux qui \xe9taient sous la domination du diable, parce que Dieu \xe9tait avec lui.`,
    `<p>Acts 10:38 (NKJV) </p> how God anointed Jesus of Nazareth with the Holy Spirit and with power, who went about doing good and healing all who were oppressed by the devil, for God was with Him.`,
    `<p>Actes 10:44 (S21)</p> Pierre parlait encore quand le Saint-Esprit descendit sur tous ceux qui \xe9coutaient la parole.`,
    `<p>Acts 10:44 (NKJV) </p> While Peter was still speaking these words, the Holy Spirit fell upon all those who heard the word.`,
    `<p>Actes 11:12-15 (S21)</p> L'Esprit m'a dit de partir avec eux sans h\xe9siter. Les six fr\xe8res que voici m'ont accompagn\xe9 et nous sommes entr\xe9s dans la maison de Corneille. Cet homme nous a racont\xe9 comment il avait vu l'ange se pr\xe9senter \xe0 lui dans sa maison et [lui] dire : \u{2018}Envoie quelqu'un \xe0 Jaffa et fais venir Simon, surnomm\xe9 Pierre ; il te dira un message par lequel tu seras sauv\xe9, toi et toute ta famille.\u{2019} Lorsque j'ai commenc\xe9 \xe0 parler, le Saint-Esprit est descendu sur eux, comme sur nous au d\xe9but.`,
    `<p>Acts 11:12-15 (NKJV) </p> Then the Spirit told me to go with them, doubting nothing. Moreover these six brethren accompanied me, and we entered the man's house. And he told us how he had seen an angel standing in his house, who said to him, "Send men to Joppa, and call for Simon whose surname is Peter, who will tell you words by which you and all your household will be saved.' And as I began to speak, the Holy Spirit fell upon them, as upon us at the beginning.`,
    `<p>Actes 13:2-4 (S21)</p> Pendant qu'ils rendaient un culte au Seigneur et qu'ils je\xfbnaient, le Saint-Esprit dit : \xab Mettez-moi \xe0 part Barnabas et Saul pour la t\xe2che \xe0 laquelle je les ai appel\xe9s. \xbb Alors, apr\xe8s avoir je\xfbn\xe9, pri\xe9 et pos\xe9 les mains sur eux, ils les laiss\xe8rent partir. Envoy\xe9s par le Saint-Esprit, Barnabas et Saul descendirent \xe0 S\xe9leucie, d'o\xf9 ils embarqu\xe8rent pour l'\xeele de Chypre.`,
    `<p>Acts 13:2-4 (NKJV) </p> As they ministered to the Lord and fasted, the Holy Spirit said, "Now separate to Me Barnabas and Saul for the work to which I have called them." Then, having fasted and prayed, and laid hands on them, they sent them away. So, being sent out by the Holy Spirit, they went down to Seleucia, and from there they sailed to Cyprus.`,
    `<p>Actes 13:9-12 (S21)</p> Alors Saul, appel\xe9 aussi Paul, rempli du Saint-Esprit, fixa les regards sur lui et dit : \xab Homme plein de toute sorte de ruse et de m\xe9chancet\xe9, fils du diable, ennemi de toute justice, ne vas-tu pas cesser de pervertir les voies droites du Seigneur ? Maintenant, voici que la main du Seigneur est sur toi : tu seras aveugle et pour un temps tu ne verras pas le soleil. \xbb L'obscurit\xe9 et les t\xe9n\xe8bres tomb\xe8rent imm\xe9diatement sur lui et il se tournait de tous c\xf4t\xe9s en cherchant quelqu\u{2019}un pour le guider. Quand il vit ce qui \xe9tait arriv\xe9, le gouverneur crut, frapp\xe9 qu\u{2019}il \xe9tait par l'enseignement du Seigneur.`,
    `<p>Acts 13:9-12 (NKJV) </p> Then Saul, who also is called Paul, filled with the Holy Spirit, looked intently at him and said, "O full of all deceit and all fraud, you son of the devil, you enemy of all righteousness, will you not cease perverting the straight ways of the Lord? And now, indeed, the hand of the Lord is upon you, and you shall be blind, not seeing the sun for a time." And immediately a dark mist fell on him, and he went around seeking someone to lead him by the hand. Then the proconsul believed, when he saw what had been done, being astonished at the teaching of the Lord.`,
    `<p>Actes 19:6 (S21)</p> Lorsque Paul posa les mains sur eux, le Saint-Esprit vint sur eux et ils se mirent \xe0 parler en langues et \xe0 proph\xe9tiser.`,
    `<p>Acts 19:6 (NKJV) </p> And when Paul had laid hands on them, the Holy Spirit came upon them, and they spoke with tongues and prophesied.`,
    `<p>Romains 5:5 (S21)</p> Or cette esp\xe9rance ne trompe pas, parce que l'amour de Dieu est d\xe9vers\xe9 dans notre c\u{153}ur par le Saint-Esprit qui nous a \xe9t\xe9 donn\xe9.`,
    `<p>Romans 5:5 (NKJV) </p> Now hope does not disappoint, because the love of God has been poured out in our hearts by the Holy Spirit who was given to us.`,
    `<p>Romains 8:15-16 (S21)</p> Et vous n'avez pas re\xe7u un esprit d'esclavage pour \xeatre encore dans la crainte, mais vous avez re\xe7u un Esprit d'adoption, par lequel nous crions : \xab Abba ! P\xe8re ! \xbb L'Esprit lui-m\xeame rend t\xe9moignage \xe0 notre esprit que nous sommes enfants de Dieu.`,
    `<p>Romans 8:15-16 (NKJV) </p> For you did not receive the spirit of bondage again to fear, but you received the Spirit of adoption by whom we cry out, "Abba, Father." The Spirit Himself bears witness with our spirit that we are children of God,`,
    `<p>1 Corinthiens 6:11 (S21)</p> Et c'est l\xe0 ce que vous \xe9tiez, certains d'entre vous. Mais vous avez \xe9t\xe9 lav\xe9s, mais vous avez \xe9t\xe9 d\xe9clar\xe9s saints, mais vous avez \xe9t\xe9 d\xe9clar\xe9s justes au nom du Seigneur J\xe9sus[-Christ] et par l'Esprit de notre Dieu.`,
    `<p>1 Corinthians 6:11 (NKJV) </p> And such were some of you. But you were washed, but you were sanctified, but you were justified in the name of the Lord Jesus and by the Spirit of our God.`,
    `<p>2 Corinthiens 3:18 (S21)</p> Nous tous qui, sans voile sur le visage, contemplons comme dans un miroir la gloire du Seigneur, nous sommes transform\xe9s \xe0 son image, de gloire en gloire, par l'Esprit du Seigneur.`,
    `<p>2 Corinthians 3:18 (NKJV) </p> But we all, with unveiled face, beholding as in a mirror the glory of the Lord, are being transformed into the same image from glory to glory, just as by the Spirit of the Lord.`,
    `<p>Galates 5:18 (S21)</p> Cependant, si vous \xeates conduits par l'Esprit, vous n'\xeates pas sous la loi.`,
    `<p>Galatians 5:18 (NKJV) </p> But if you are led by the Spirit, you are not under the law.`,
    `<p>\xc9ph\xe9siens 4:30 (S21)</p> N'attristez pas le Saint-Esprit de Dieu, par lequel vous avez \xe9t\xe9 marqu\xe9s d\u{2019}une empreinte pour le jour de la lib\xe9ration.`,
    `<p>Ephesians 4:30 (NKJV) </p> And do not grieve the Holy Spirit of God, by whom you were sealed for the day of redemption.`,
    `<p>Job 32:8 (S21)</p> Mais en r\xe9alit\xe9, dans l'homme, c'est l'Esprit, le souffle du Tout-Puissant qui donne la capacit\xe9 de comprendre.`,
    `<p>Job 32:8 (NKJV) </p> But there is a spirit in man, And the breath of the Almighty gives him understanding.`
];
var $56f685a6bdc4117b$export$2e2bcd8739ae039 = $56f685a6bdc4117b$var$versesBucket;


var $91310346c791545d$exports = {};
var $7643641a377e4c74$exports = {};
'use strict';
/* eslint-env browser */ $7643641a377e4c74$exports = typeof self === 'object' ? self.FormData : window.FormData;


var $affd14ba9dd8837a$exports = {};
/*! For license information please see mailgun.web.js.LICENSE.txt */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $899c2e2427e3f52f$export$a143d493d941bafc;
var $899c2e2427e3f52f$export$e4cf37d7f6fb9e0a;
var $899c2e2427e3f52f$export$f99ded8fe4b79145;
var $899c2e2427e3f52f$export$599f31c3813fae4d;
'use strict';
var $ebda4751637fc70e$export$a48f0734ac7c2329;
var $ebda4751637fc70e$export$d622b2ad8d90c771;
var $ebda4751637fc70e$export$6100ba28696e12de;
'use strict';
$ebda4751637fc70e$export$a48f0734ac7c2329 = $ebda4751637fc70e$var$byteLength;
$ebda4751637fc70e$export$d622b2ad8d90c771 = $ebda4751637fc70e$var$toByteArray;
$ebda4751637fc70e$export$6100ba28696e12de = $ebda4751637fc70e$var$fromByteArray;
var $ebda4751637fc70e$var$lookup = [];
var $ebda4751637fc70e$var$revLookup = [];
var $ebda4751637fc70e$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $ebda4751637fc70e$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $ebda4751637fc70e$var$i = 0, $ebda4751637fc70e$var$len = $ebda4751637fc70e$var$code.length; $ebda4751637fc70e$var$i < $ebda4751637fc70e$var$len; ++$ebda4751637fc70e$var$i){
    $ebda4751637fc70e$var$lookup[$ebda4751637fc70e$var$i] = $ebda4751637fc70e$var$code[$ebda4751637fc70e$var$i];
    $ebda4751637fc70e$var$revLookup[$ebda4751637fc70e$var$code.charCodeAt($ebda4751637fc70e$var$i)] = $ebda4751637fc70e$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ebda4751637fc70e$var$revLookup['-'.charCodeAt(0)] = 62;
$ebda4751637fc70e$var$revLookup['_'.charCodeAt(0)] = 63;
function $ebda4751637fc70e$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ebda4751637fc70e$var$byteLength(b64) {
    var lens = $ebda4751637fc70e$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ebda4751637fc70e$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ebda4751637fc70e$var$toByteArray(b64) {
    var tmp;
    var lens = $ebda4751637fc70e$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ebda4751637fc70e$var$Arr($ebda4751637fc70e$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i)] << 18 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i)] << 2 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i)] << 10 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ebda4751637fc70e$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ebda4751637fc70e$var$tripletToBase64(num) {
    return $ebda4751637fc70e$var$lookup[num >> 18 & 0x3F] + $ebda4751637fc70e$var$lookup[num >> 12 & 0x3F] + $ebda4751637fc70e$var$lookup[num >> 6 & 0x3F] + $ebda4751637fc70e$var$lookup[num & 0x3F];
}
function $ebda4751637fc70e$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ebda4751637fc70e$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $ebda4751637fc70e$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ebda4751637fc70e$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ebda4751637fc70e$var$lookup[tmp >> 2] + $ebda4751637fc70e$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ebda4751637fc70e$var$lookup[tmp >> 10] + $ebda4751637fc70e$var$lookup[tmp >> 4 & 0x3F] + $ebda4751637fc70e$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2a1805d219a3a5f0$export$aafa59e2e03f2942;
var $2a1805d219a3a5f0$export$68d8715fc104d294;
$2a1805d219a3a5f0$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2a1805d219a3a5f0$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $899c2e2427e3f52f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$899c2e2427e3f52f$export$a143d493d941bafc = $899c2e2427e3f52f$var$Buffer;
$899c2e2427e3f52f$export$e4cf37d7f6fb9e0a = $899c2e2427e3f52f$var$SlowBuffer;
$899c2e2427e3f52f$export$f99ded8fe4b79145 = 50;
const $899c2e2427e3f52f$var$K_MAX_LENGTH = 0x7fffffff;
$899c2e2427e3f52f$export$599f31c3813fae4d = $899c2e2427e3f52f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $899c2e2427e3f52f$var$Buffer.TYPED_ARRAY_SUPPORT = $899c2e2427e3f52f$var$typedArraySupport();
if (!$899c2e2427e3f52f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $899c2e2427e3f52f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($899c2e2427e3f52f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$899c2e2427e3f52f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($899c2e2427e3f52f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$899c2e2427e3f52f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $899c2e2427e3f52f$var$createBuffer(length) {
    if (length > $899c2e2427e3f52f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $899c2e2427e3f52f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $899c2e2427e3f52f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $899c2e2427e3f52f$var$allocUnsafe(arg);
    }
    return $899c2e2427e3f52f$var$from(arg, encodingOrOffset, length);
}
$899c2e2427e3f52f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $899c2e2427e3f52f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $899c2e2427e3f52f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $899c2e2427e3f52f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($899c2e2427e3f52f$var$isInstance(value, ArrayBuffer) || value && $899c2e2427e3f52f$var$isInstance(value.buffer, ArrayBuffer)) return $899c2e2427e3f52f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($899c2e2427e3f52f$var$isInstance(value, SharedArrayBuffer) || value && $899c2e2427e3f52f$var$isInstance(value.buffer, SharedArrayBuffer))) return $899c2e2427e3f52f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $899c2e2427e3f52f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $899c2e2427e3f52f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $899c2e2427e3f52f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $899c2e2427e3f52f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $899c2e2427e3f52f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($899c2e2427e3f52f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($899c2e2427e3f52f$var$Buffer, Uint8Array);
function $899c2e2427e3f52f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $899c2e2427e3f52f$var$alloc(size, fill, encoding) {
    $899c2e2427e3f52f$var$assertSize(size);
    if (size <= 0) return $899c2e2427e3f52f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $899c2e2427e3f52f$var$createBuffer(size).fill(fill, encoding) : $899c2e2427e3f52f$var$createBuffer(size).fill(fill);
    return $899c2e2427e3f52f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $899c2e2427e3f52f$var$Buffer.alloc = function(size, fill, encoding) {
    return $899c2e2427e3f52f$var$alloc(size, fill, encoding);
};
function $899c2e2427e3f52f$var$allocUnsafe(size) {
    $899c2e2427e3f52f$var$assertSize(size);
    return $899c2e2427e3f52f$var$createBuffer(size < 0 ? 0 : $899c2e2427e3f52f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $899c2e2427e3f52f$var$Buffer.allocUnsafe = function(size) {
    return $899c2e2427e3f52f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $899c2e2427e3f52f$var$Buffer.allocUnsafeSlow = function(size) {
    return $899c2e2427e3f52f$var$allocUnsafe(size);
};
function $899c2e2427e3f52f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$899c2e2427e3f52f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $899c2e2427e3f52f$var$byteLength(string, encoding) | 0;
    let buf = $899c2e2427e3f52f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $899c2e2427e3f52f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $899c2e2427e3f52f$var$checked(array.length) | 0;
    const buf = $899c2e2427e3f52f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $899c2e2427e3f52f$var$fromArrayView(arrayView) {
    if ($899c2e2427e3f52f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $899c2e2427e3f52f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $899c2e2427e3f52f$var$fromArrayLike(arrayView);
}
function $899c2e2427e3f52f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $899c2e2427e3f52f$var$Buffer.prototype);
    return buf;
}
function $899c2e2427e3f52f$var$fromObject(obj) {
    if ($899c2e2427e3f52f$var$Buffer.isBuffer(obj)) {
        const len = $899c2e2427e3f52f$var$checked(obj.length) | 0;
        const buf = $899c2e2427e3f52f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $899c2e2427e3f52f$var$numberIsNaN(obj.length)) return $899c2e2427e3f52f$var$createBuffer(0);
        return $899c2e2427e3f52f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $899c2e2427e3f52f$var$fromArrayLike(obj.data);
}
function $899c2e2427e3f52f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $899c2e2427e3f52f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $899c2e2427e3f52f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $899c2e2427e3f52f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $899c2e2427e3f52f$var$Buffer.alloc(+length);
}
$899c2e2427e3f52f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $899c2e2427e3f52f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$899c2e2427e3f52f$var$Buffer.compare = function compare(a, b) {
    if ($899c2e2427e3f52f$var$isInstance(a, Uint8Array)) a = $899c2e2427e3f52f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($899c2e2427e3f52f$var$isInstance(b, Uint8Array)) b = $899c2e2427e3f52f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$899c2e2427e3f52f$var$Buffer.isBuffer(a) || !$899c2e2427e3f52f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$899c2e2427e3f52f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$899c2e2427e3f52f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $899c2e2427e3f52f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $899c2e2427e3f52f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($899c2e2427e3f52f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$899c2e2427e3f52f$var$Buffer.isBuffer(buf)) buf = $899c2e2427e3f52f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$899c2e2427e3f52f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $899c2e2427e3f52f$var$byteLength(string, encoding) {
    if ($899c2e2427e3f52f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $899c2e2427e3f52f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $899c2e2427e3f52f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $899c2e2427e3f52f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $899c2e2427e3f52f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$899c2e2427e3f52f$var$Buffer.byteLength = $899c2e2427e3f52f$var$byteLength;
function $899c2e2427e3f52f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $899c2e2427e3f52f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $899c2e2427e3f52f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $899c2e2427e3f52f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $899c2e2427e3f52f$var$latin1Slice(this, start, end);
        case 'base64':
            return $899c2e2427e3f52f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $899c2e2427e3f52f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$899c2e2427e3f52f$var$Buffer.prototype._isBuffer = true;
function $899c2e2427e3f52f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$899c2e2427e3f52f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$899c2e2427e3f52f$var$swap(this, i, i + 1);
    return this;
};
$899c2e2427e3f52f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $899c2e2427e3f52f$var$swap(this, i, i + 3);
        $899c2e2427e3f52f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$899c2e2427e3f52f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $899c2e2427e3f52f$var$swap(this, i, i + 7);
        $899c2e2427e3f52f$var$swap(this, i + 1, i + 6);
        $899c2e2427e3f52f$var$swap(this, i + 2, i + 5);
        $899c2e2427e3f52f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$899c2e2427e3f52f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $899c2e2427e3f52f$var$utf8Slice(this, 0, length);
    return $899c2e2427e3f52f$var$slowToString.apply(this, arguments);
};
$899c2e2427e3f52f$var$Buffer.prototype.toLocaleString = $899c2e2427e3f52f$var$Buffer.prototype.toString;
$899c2e2427e3f52f$var$Buffer.prototype.equals = function equals(b) {
    if (!$899c2e2427e3f52f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $899c2e2427e3f52f$var$Buffer.compare(this, b) === 0;
};
$899c2e2427e3f52f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $899c2e2427e3f52f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($899c2e2427e3f52f$var$customInspectSymbol) $899c2e2427e3f52f$var$Buffer.prototype[$899c2e2427e3f52f$var$customInspectSymbol] = $899c2e2427e3f52f$var$Buffer.prototype.inspect;
$899c2e2427e3f52f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($899c2e2427e3f52f$var$isInstance(target, Uint8Array)) target = $899c2e2427e3f52f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$899c2e2427e3f52f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $899c2e2427e3f52f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($899c2e2427e3f52f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $899c2e2427e3f52f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($899c2e2427e3f52f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $899c2e2427e3f52f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $899c2e2427e3f52f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $899c2e2427e3f52f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$899c2e2427e3f52f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$899c2e2427e3f52f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $899c2e2427e3f52f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$899c2e2427e3f52f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $899c2e2427e3f52f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $899c2e2427e3f52f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($899c2e2427e3f52f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $899c2e2427e3f52f$var$utf8Write(buf, string, offset, length) {
    return $899c2e2427e3f52f$var$blitBuffer($899c2e2427e3f52f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $899c2e2427e3f52f$var$asciiWrite(buf, string, offset, length) {
    return $899c2e2427e3f52f$var$blitBuffer($899c2e2427e3f52f$var$asciiToBytes(string), buf, offset, length);
}
function $899c2e2427e3f52f$var$base64Write(buf, string, offset, length) {
    return $899c2e2427e3f52f$var$blitBuffer($899c2e2427e3f52f$var$base64ToBytes(string), buf, offset, length);
}
function $899c2e2427e3f52f$var$ucs2Write(buf, string, offset, length) {
    return $899c2e2427e3f52f$var$blitBuffer($899c2e2427e3f52f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$899c2e2427e3f52f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $899c2e2427e3f52f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $899c2e2427e3f52f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $899c2e2427e3f52f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $899c2e2427e3f52f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $899c2e2427e3f52f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$899c2e2427e3f52f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $899c2e2427e3f52f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ebda4751637fc70e$export$6100ba28696e12de(buf);
    else return $ebda4751637fc70e$export$6100ba28696e12de(buf.slice(start, end));
}
function $899c2e2427e3f52f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $899c2e2427e3f52f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $899c2e2427e3f52f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $899c2e2427e3f52f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $899c2e2427e3f52f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $899c2e2427e3f52f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $899c2e2427e3f52f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $899c2e2427e3f52f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $899c2e2427e3f52f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $899c2e2427e3f52f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $899c2e2427e3f52f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$899c2e2427e3f52f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $899c2e2427e3f52f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $899c2e2427e3f52f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$899c2e2427e3f52f$var$Buffer.prototype.readUintLE = $899c2e2427e3f52f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readUintBE = $899c2e2427e3f52f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readUint8 = $899c2e2427e3f52f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$899c2e2427e3f52f$var$Buffer.prototype.readUint16LE = $899c2e2427e3f52f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$899c2e2427e3f52f$var$Buffer.prototype.readUint16BE = $899c2e2427e3f52f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$899c2e2427e3f52f$var$Buffer.prototype.readUint32LE = $899c2e2427e3f52f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$899c2e2427e3f52f$var$Buffer.prototype.readUint32BE = $899c2e2427e3f52f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$899c2e2427e3f52f$var$Buffer.prototype.readBigUInt64LE = $899c2e2427e3f52f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $899c2e2427e3f52f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $899c2e2427e3f52f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$899c2e2427e3f52f$var$Buffer.prototype.readBigUInt64BE = $899c2e2427e3f52f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $899c2e2427e3f52f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $899c2e2427e3f52f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$899c2e2427e3f52f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$899c2e2427e3f52f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$899c2e2427e3f52f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$899c2e2427e3f52f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$899c2e2427e3f52f$var$Buffer.prototype.readBigInt64LE = $899c2e2427e3f52f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $899c2e2427e3f52f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $899c2e2427e3f52f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$899c2e2427e3f52f$var$Buffer.prototype.readBigInt64BE = $899c2e2427e3f52f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $899c2e2427e3f52f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $899c2e2427e3f52f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$899c2e2427e3f52f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return $2a1805d219a3a5f0$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$899c2e2427e3f52f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 4, this.length);
    return $2a1805d219a3a5f0$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$899c2e2427e3f52f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 8, this.length);
    return $2a1805d219a3a5f0$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$899c2e2427e3f52f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkOffset(offset, 8, this.length);
    return $2a1805d219a3a5f0$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $899c2e2427e3f52f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$899c2e2427e3f52f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$899c2e2427e3f52f$var$Buffer.prototype.writeUintLE = $899c2e2427e3f52f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $899c2e2427e3f52f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUintBE = $899c2e2427e3f52f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $899c2e2427e3f52f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUint8 = $899c2e2427e3f52f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUint16LE = $899c2e2427e3f52f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUint16BE = $899c2e2427e3f52f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUint32LE = $899c2e2427e3f52f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeUint32BE = $899c2e2427e3f52f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $899c2e2427e3f52f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $899c2e2427e3f52f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $899c2e2427e3f52f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $899c2e2427e3f52f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$899c2e2427e3f52f$var$Buffer.prototype.writeBigUInt64LE = $899c2e2427e3f52f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $899c2e2427e3f52f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$899c2e2427e3f52f$var$Buffer.prototype.writeBigUInt64BE = $899c2e2427e3f52f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $899c2e2427e3f52f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$899c2e2427e3f52f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $899c2e2427e3f52f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $899c2e2427e3f52f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$899c2e2427e3f52f$var$Buffer.prototype.writeBigInt64LE = $899c2e2427e3f52f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $899c2e2427e3f52f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$899c2e2427e3f52f$var$Buffer.prototype.writeBigInt64BE = $899c2e2427e3f52f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $899c2e2427e3f52f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $899c2e2427e3f52f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $899c2e2427e3f52f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2a1805d219a3a5f0$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$899c2e2427e3f52f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $899c2e2427e3f52f$var$writeFloat(this, value, offset, true, noAssert);
};
$899c2e2427e3f52f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $899c2e2427e3f52f$var$writeFloat(this, value, offset, false, noAssert);
};
function $899c2e2427e3f52f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $899c2e2427e3f52f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2a1805d219a3a5f0$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$899c2e2427e3f52f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $899c2e2427e3f52f$var$writeDouble(this, value, offset, true, noAssert);
};
$899c2e2427e3f52f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $899c2e2427e3f52f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$899c2e2427e3f52f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$899c2e2427e3f52f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$899c2e2427e3f52f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$899c2e2427e3f52f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $899c2e2427e3f52f$var$Buffer.isBuffer(val) ? val : $899c2e2427e3f52f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $899c2e2427e3f52f$var$errors = {};
function $899c2e2427e3f52f$var$E(sym, getMessage, Base) {
    $899c2e2427e3f52f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$899c2e2427e3f52f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$899c2e2427e3f52f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$899c2e2427e3f52f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $899c2e2427e3f52f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $899c2e2427e3f52f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $899c2e2427e3f52f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $899c2e2427e3f52f$var$checkBounds(buf, offset, byteLength) {
    $899c2e2427e3f52f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $899c2e2427e3f52f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $899c2e2427e3f52f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $899c2e2427e3f52f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $899c2e2427e3f52f$var$checkBounds(buf, offset, byteLength);
}
function $899c2e2427e3f52f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $899c2e2427e3f52f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $899c2e2427e3f52f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $899c2e2427e3f52f$var$validateNumber(value, type);
        throw new $899c2e2427e3f52f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $899c2e2427e3f52f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $899c2e2427e3f52f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $899c2e2427e3f52f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $899c2e2427e3f52f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($899c2e2427e3f52f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $899c2e2427e3f52f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $899c2e2427e3f52f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $899c2e2427e3f52f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $899c2e2427e3f52f$var$base64ToBytes(str) {
    return $ebda4751637fc70e$export$d622b2ad8d90c771($899c2e2427e3f52f$var$base64clean(str));
}
function $899c2e2427e3f52f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $899c2e2427e3f52f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $899c2e2427e3f52f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $899c2e2427e3f52f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $899c2e2427e3f52f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $899c2e2427e3f52f$var$BufferBigIntNotDefined : fn;
}
function $899c2e2427e3f52f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $affd14ba9dd8837a$require$Buffer = $899c2e2427e3f52f$export$a143d493d941bafc;
!function(t, e) {
    $affd14ba9dd8837a$exports = e();
}($affd14ba9dd8837a$exports, function() {
    return (()=>{
        var t = {
            48: function(t, e, r) {
                "use strict";
                var n = (this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                })(r(475)), s = function() {
                    function t(t) {
                        this.formData = t;
                    }
                    return t.prototype.client = function(t) {
                        return new n.default(t, this.formData);
                    }, t;
                }();
                t.exports = s;
            },
            475: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var o = s(r(438)), i = s(r(373)), a = s(r(22)), u = s(r(747)), h = s(r(778)), p = s(r(750)), c = s(r(197)), f = s(r(277)), l = s(r(721)), d = s(r(345)), y = s(r(602)), m = s(r(126)), v = s(r(135)), b = s(r(60)), g = s(r(734)), _ = s(r(955)), w = s(r(75)), q = function(t, e) {
                    var r = n({}, t);
                    if (r.url || (r.url = "https://api.mailgun.net"), !r.username) throw new Error('Parameter "username" is required');
                    if (!r.key) throw new Error('Parameter "key" is required');
                    this.request = new o.default(r, e);
                    var s = new v.default(this.request), q = new b.default(this.request), R = new _.default(this.request), D = new w.default(this.request), j = new g.default(this.request);
                    this.domains = new i.default(this.request, q, R, D), this.webhooks = new p.default(this.request), this.events = new a.default(this.request), this.stats = new u.default(this.request), this.suppressions = new h.default(this.request), this.messages = new c.default(this.request), this.routes = new f.default(this.request), this.ips = new d.default(this.request), this.ip_pools = new y.default(this.request), this.lists = new m.default(this.request, s), this.validate = new l.default(this.request, j);
                };
                e.default = q;
            },
            373: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.Domain = void 0;
                var o = s(r(78)), i = s(r(142)), a = function(t, e, r) {
                    this.name = t.name, this.require_tls = t.require_tls, this.skip_verification = t.skip_verification, this.state = t.state, this.wildcard = t.wildcard, this.spam_action = t.spam_action, this.created_at = t.created_at, this.smtp_password = t.smtp_password, this.smtp_login = t.smtp_login, this.type = t.type, this.receiving_dns_records = e || null, this.sending_dns_records = r || null;
                };
                e.Domain = a;
                var u = function() {
                    function t(t, e, r, n) {
                        this.request = t, this.domainCredentials = e, this.domainTemplates = r, this.domainTags = n;
                    }
                    return t.prototype._parseMessage = function(t) {
                        return t.body;
                    }, t.prototype._parseDomainList = function(t) {
                        return t.body.items.map(function(t) {
                            return new a(t);
                        });
                    }, t.prototype._parseDomain = function(t) {
                        return new a(t.body.domain, t.body.receiving_dns_records, t.body.sending_dns_records);
                    }, t.prototype._parseTrackingSettings = function(t) {
                        return t.body.tracking;
                    }, t.prototype._parseTrackingUpdate = function(t) {
                        return t.body;
                    }, t.prototype.list = function(t) {
                        var e = this;
                        return this.request.get("/v3/domains", t).then(function(t) {
                            return e._parseDomainList(t);
                        });
                    }, t.prototype.get = function(t) {
                        var e = this;
                        return this.request.get("/v3/domains/" + t).then(function(t) {
                            return e._parseDomain(t);
                        });
                    }, t.prototype.create = function(t) {
                        var e = this, r = n({}, t);
                        return "force_dkim_authority" in r && "boolean" == typeof r.force_dkim_authority && (r.force_dkim_authority = "true" === r.toString() ? "true" : "false"), this.request.postWithFD("/v3/domains", r).then(function(t) {
                            return e._parseDomain(t);
                        });
                    }, t.prototype.destroy = function(t) {
                        var e = this;
                        return this.request.delete("/v3/domains/" + t).then(function(t) {
                            return e._parseMessage(t);
                        });
                    }, t.prototype.getConnection = function(t) {
                        return this.request.get("/v3/domains/" + t + "/connection").then(function(t) {
                            return t;
                        }).then(function(t) {
                            return t.body.connection;
                        });
                    }, t.prototype.updateConnection = function(t, e) {
                        return this.request.put("/v3/domains/" + t + "/connection", e).then(function(t) {
                            return t;
                        }).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.getTracking = function(t) {
                        return this.request.get((0, o.default)("/v3/domains", t, "tracking")).then(this._parseTrackingSettings);
                    }, t.prototype.updateTracking = function(t, e, r) {
                        var n = this;
                        if ("boolean" == typeof (null == r ? void 0 : r.active)) throw new i.default({
                            status: 400,
                            statusText: "",
                            body: {
                                message: 'Property "active" must contain string value.'
                            }
                        });
                        return this.request.putWithFD((0, o.default)("/v3/domains", t, "tracking", e), r).then(function(t) {
                            return n._parseTrackingUpdate(t);
                        });
                    }, t.prototype.getIps = function(t) {
                        return this.request.get((0, o.default)("/v3/domains", t, "ips")).then(function(t) {
                            var e;
                            return null === (e = null == t ? void 0 : t.body) || void 0 === e ? void 0 : e.items;
                        });
                    }, t.prototype.assignIp = function(t, e) {
                        return this.request.postWithFD((0, o.default)("/v3/domains", t, "ips"), {
                            ip: e
                        });
                    }, t.prototype.deleteIp = function(t, e) {
                        return this.request.delete((0, o.default)("/v3/domains", t, "ips", e));
                    }, t.prototype.linkIpPool = function(t, e) {
                        return this.request.postWithFD((0, o.default)("/v3/domains", t, "ips"), {
                            pool_id: e
                        });
                    }, t.prototype.unlinkIpPoll = function(t, e) {
                        var r = "";
                        if (e.pool_id && e.ip) throw new i.default({
                            status: 400,
                            statusText: "",
                            body: {
                                message: "Please specify either pool_id or ip (not both)"
                            }
                        });
                        return e.pool_id ? r = "?pool_id=" + e.pool_id : e.ip && (r = "?ip=" + e.ip), this.request.delete((0, o.default)("/v3/domains", t, "ips", "ip_pool", r));
                    }, t.prototype.updateDKIMAuthority = function(t, e) {
                        return this.request.put("/v3/domains/" + t + "/dkim_authority", {}, {
                            query: "self=" + e.self
                        }).then(function(t) {
                            return t;
                        }).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.updateDKIMSelector = function(t, e) {
                        return this.request.put("/v3/domains/" + t + "/dkim_selector", {}, {
                            query: "dkim_selector=" + e.dkimSelector
                        }).then(function(t) {
                            return t;
                        });
                    }, t.prototype.updateWebPrefix = function(t, e) {
                        return this.request.put("/v3/domains/" + t + "/web_prefix", {}, {
                            query: "web_prefix=" + e.webPrefix
                        }).then(function(t) {
                            return t;
                        });
                    }, t;
                }();
                e.default = u;
            },
            60: function(t, e, r) {
                "use strict";
                var n = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = n(r(78)), o = function() {
                    function t(t) {
                        this.request = t, this.baseRoute = "/v3/domains/";
                    }
                    return t.prototype._parseDomainCredentialsList = function(t) {
                        return {
                            items: t.body.items,
                            totalCount: t.body.total_count
                        };
                    }, t.prototype._parseMessageResponse = function(t) {
                        return {
                            status: t.status,
                            message: t.body.message
                        };
                    }, t.prototype._parseDeletedResponse = function(t) {
                        return {
                            status: t.status,
                            message: t.body.message,
                            spec: t.body.spec
                        };
                    }, t.prototype.list = function(t, e) {
                        var r = this;
                        return this.request.get((0, s.default)(this.baseRoute, t, "/credentials"), e).then(function(t) {
                            return r._parseDomainCredentialsList(t);
                        });
                    }, t.prototype.create = function(t, e) {
                        var r = this;
                        return this.request.postWithFD("" + this.baseRoute + t + "/credentials", e).then(function(t) {
                            return r._parseMessageResponse(t);
                        });
                    }, t.prototype.update = function(t, e, r) {
                        var n = this;
                        return this.request.putWithFD("" + this.baseRoute + t + "/credentials/" + e, r).then(function(t) {
                            return n._parseMessageResponse(t);
                        });
                    }, t.prototype.destroy = function(t, e) {
                        var r = this;
                        return this.request.delete("" + this.baseRoute + t + "/credentials/" + e).then(function(t) {
                            return r._parseDeletedResponse(t);
                        });
                    }, t;
                }();
                e.default = o;
            },
            75: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DomainTagStatistic = e.DomainTag = void 0;
                var o = s(r(78)), i = function(t) {
                    this.tag = t.tag, this.description = t.description, this["first-seen"] = new Date(t["first-seen"]), this["last-seen"] = new Date(t["last-seen"]);
                };
                e.DomainTag = i;
                var a = function(t) {
                    this.tag = t.body.tag, this.description = t.body.description, this.start = new Date(t.body.start), this.end = new Date(t.body.end), this.resolution = t.body.resolution, this.stats = t.body.stats.map(function(t) {
                        return n(n({}, t), {
                            time: new Date(t.time)
                        });
                    });
                };
                e.DomainTagStatistic = a;
                var u = function() {
                    function t(t) {
                        this.request = t, this.baseRoute = "/v3/";
                    }
                    return t.prototype._parsePageLinks = function(t) {
                        return Object.entries(t.body.paging).reduce(function(t, e) {
                            var r = e[0], n = e[1];
                            return t[r] = {
                                id: r,
                                url: n
                            }, t;
                        }, {});
                    }, t.prototype._parseDomainTagsList = function(t) {
                        return {
                            items: t.body.items.map(function(t) {
                                return new i(t);
                            }),
                            pages: this._parsePageLinks(t)
                        };
                    }, t.prototype._parseTagStatistic = function(t) {
                        return new a(t);
                    }, t.prototype.list = function(t, e) {
                        var r = this;
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags"), e).then(function(t) {
                            return r._parseDomainTagsList(t);
                        });
                    }, t.prototype.get = function(t, e) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e)).then(function(t) {
                            return new i(t.body);
                        });
                    }, t.prototype.update = function(t, e, r) {
                        return this.request.put((0, o.default)(this.baseRoute, t, "/tags", e), r).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.destroy = function(t, e) {
                        return this.request.delete("" + this.baseRoute + t + "/tags/" + e).then(function(t) {
                            return {
                                message: t.body.message,
                                status: t.status
                            };
                        });
                    }, t.prototype.statistic = function(t, e, r) {
                        var n = this;
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats"), r).then(function(t) {
                            return n._parseTagStatistic(t);
                        });
                    }, t.prototype.countries = function(t, e) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/countries")).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.providers = function(t, e) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/providers")).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.devices = function(t, e) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/tags", e, "stats/aggregates/devices")).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = u;
            },
            955: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                }), e.DomainTemplateItem = void 0;
                var o = s(r(78)), i = function(t) {
                    this.name = t.name, this.description = t.description, this.createdAt = t.createdAt ? new Date(t.createdAt) : "", this.createdBy = t.createdBy, this.id = t.id, t.version && (this.version = t.version, t.version.createdAt && (this.version.createdAt = new Date(t.version.createdAt))), t.versions && t.versions.length && (this.versions = t.versions.map(function(t) {
                        var e = n({}, t);
                        return e.createdAt = new Date(t.createdAt), e;
                    }));
                };
                e.DomainTemplateItem = i;
                var a = function() {
                    function t(t) {
                        this.request = t, this.baseRoute = "/v3/";
                    }
                    return t.prototype.parseCreationResponse = function(t) {
                        return new i(t.body.template);
                    }, t.prototype.parseCreationVersionResponse = function(t) {
                        var e = {};
                        return e.status = t.status, e.message = t.body.message, t.body && t.body.template && (e.template = new i(t.body.template)), e;
                    }, t.prototype.parseMutationResponse = function(t) {
                        var e = {};
                        return e.status = t.status, e.message = t.body.message, t.body && t.body.template && (e.templateName = t.body.template.name), e;
                    }, t.prototype.parseNotificationResponse = function(t) {
                        var e = {};
                        return e.status = t.status, e.message = t.body.message, e;
                    }, t.prototype.parseMutateTemplateVersionResponse = function(t) {
                        var e = {};
                        return e.status = t.status, e.message = t.body.message, t.body.template && (e.templateName = t.body.template.name, e.templateVersion = {
                            tag: t.body.template.version.tag
                        }), e;
                    }, t.prototype.parseList = function(t) {
                        var e = {};
                        return e.items = t.body.items.map(function(t) {
                            return new i(t);
                        }), e.pages = t.body.paging, e;
                    }, t.prototype.parseListTemplateVersions = function(t) {
                        var e = {};
                        return e.template = new i(t.body.template), e.pages = t.body.paging, e;
                    }, t.prototype.list = function(t, e) {
                        var r = this;
                        return this.request.get((0, o.default)(this.baseRoute, t, "/templates"), e).then(function(t) {
                            return r.parseList(t);
                        });
                    }, t.prototype.get = function(t, e, r) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/templates/", e), r).then(function(t) {
                            return new i(t.body.template);
                        });
                    }, t.prototype.create = function(t, e) {
                        var r = this;
                        return this.request.postWithFD((0, o.default)(this.baseRoute, t, "/templates"), e).then(function(t) {
                            return r.parseCreationResponse(t);
                        });
                    }, t.prototype.update = function(t, e, r) {
                        var n = this;
                        return this.request.putWithFD((0, o.default)(this.baseRoute, t, "/templates/", e), r).then(function(t) {
                            return n.parseMutationResponse(t);
                        });
                    }, t.prototype.destroy = function(t, e) {
                        var r = this;
                        return this.request.delete((0, o.default)(this.baseRoute, t, "/templates/", e)).then(function(t) {
                            return r.parseMutationResponse(t);
                        });
                    }, t.prototype.destroyAll = function(t) {
                        var e = this;
                        return this.request.delete((0, o.default)(this.baseRoute, t, "/templates")).then(function(t) {
                            return e.parseNotificationResponse(t);
                        });
                    }, t.prototype.createVersion = function(t, e, r) {
                        var n = this;
                        return this.request.postWithFD((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions"), r).then(function(t) {
                            return n.parseCreationVersionResponse(t);
                        });
                    }, t.prototype.getVersion = function(t, e, r) {
                        return this.request.get((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r)).then(function(t) {
                            return new i(t.body.template);
                        });
                    }, t.prototype.updateVersion = function(t, e, r, n) {
                        var s = this;
                        return this.request.putWithFD((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r), n).then(function(t) {
                            return s.parseMutateTemplateVersionResponse(t);
                        });
                    }, t.prototype.destroyVersion = function(t, e, r) {
                        var n = this;
                        return this.request.delete((0, o.default)(this.baseRoute, t, "/templates/", e, "/versions/", r)).then(function(t) {
                            return n.parseMutateTemplateVersionResponse(t);
                        });
                    }, t.prototype.listVersions = function(t, e, r) {
                        var n = this;
                        return this.request.get((0, o.default)(this.baseRoute, t, "/templates", e, "/versions"), r).then(function(t) {
                            return n.parseListTemplateVersions(t);
                        });
                    }, t;
                }();
                e.default = a;
            },
            142: function(t, e) {
                "use strict";
                var r, n = this && this.__extends || (r = function(t, e) {
                    return r = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(t, e) {
                        t.__proto__ = e;
                    } || function(t, e) {
                        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
                    }, r(t, e);
                }, function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
                    function n() {
                        this.constructor = t;
                    }
                    r(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
                });
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = function(t) {
                    function e(e) {
                        var r = e.status, n = e.statusText, s = e.message, o = e.body, i = void 0 === o ? {} : o, a = this, u = i.message, h = i.error;
                        return (a = t.call(this) || this).stack = "", a.status = r, a.message = s || h || n, a.details = u, a;
                    }
                    return n(e, t), e;
                }(Error);
                e.default = s;
            },
            22: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var o = s(r(78)), i = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype._parsePageNumber = function(t) {
                        return t.split("/").pop();
                    }, t.prototype._parsePage = function(t, e) {
                        return {
                            id: t,
                            number: this._parsePageNumber(e),
                            url: e
                        };
                    }, t.prototype._parsePageLinks = function(t) {
                        var e = this;
                        return Object.entries(t.body.paging).reduce(function(t, r) {
                            var n = r[0], s = r[1];
                            return t[n] = e._parsePage(n, s), t;
                        }, {});
                    }, t.prototype._parseEventList = function(t) {
                        return {
                            items: t.body.items,
                            pages: this._parsePageLinks(t)
                        };
                    }, t.prototype.get = function(t, e) {
                        var r, s = this, i = n({}, e);
                        return i && i.page ? (r = (0, o.default)("/v3", t, "events", i.page), delete i.page) : r = (0, o.default)("/v3", t, "events"), this.request.get(r, i).then(function(t) {
                            return s._parseEventList(t);
                        });
                    }, t;
                }();
                e.default = i;
            },
            602: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype.list = function(t) {
                        var e = this;
                        return this.request.get("/v1/ip_pools", t).then(function(t) {
                            return e.parseIpPoolsResponse(t);
                        });
                    }, t.prototype.create = function(t) {
                        return this.request.postWithFD("/v1/ip_pools", t).then(function(t) {
                            return null == t ? void 0 : t.body;
                        });
                    }, t.prototype.update = function(t, e) {
                        return this.request.patchWithFD("/v1/ip_pools/" + t, e).then(function(t) {
                            return null == t ? void 0 : t.body;
                        });
                    }, t.prototype.delete = function(t, e) {
                        return this.request.delete("/v1/ip_pools/" + t, e).then(function(t) {
                            return null == t ? void 0 : t.body;
                        });
                    }, t.prototype.parseIpPoolsResponse = function(t) {
                        return t.body.ip_pools;
                    }, t;
                }();
                e.default = r;
            },
            345: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype.list = function(t) {
                        var e = this;
                        return this.request.get("/v3/ips", t).then(function(t) {
                            return e.parseIpsResponse(t);
                        });
                    }, t.prototype.get = function(t) {
                        var e = this;
                        return this.request.get("/v3/ips/" + t).then(function(t) {
                            return e.parseIpsResponse(t);
                        });
                    }, t.prototype.parseIpsResponse = function(t) {
                        return t.body;
                    }, t;
                }();
                e.default = r;
            },
            126: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t, e) {
                        this.request = t, this.baseRoute = "/v3/lists", this.members = e;
                    }
                    return t.prototype.list = function(t) {
                        return this.request.get(this.baseRoute + "/pages", t).then(function(t) {
                            return t.body.items;
                        });
                    }, t.prototype.get = function(t) {
                        return this.request.get(this.baseRoute + "/" + t).then(function(t) {
                            return t.body.list;
                        });
                    }, t.prototype.create = function(t) {
                        return this.request.postWithFD(this.baseRoute, t).then(function(t) {
                            return t.body.list;
                        });
                    }, t.prototype.update = function(t, e) {
                        return this.request.putWithFD(this.baseRoute + "/" + t, e).then(function(t) {
                            return t.body.list;
                        });
                    }, t.prototype.destroy = function(t) {
                        return this.request.delete(this.baseRoute + "/" + t).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = r;
            },
            135: function(t, e) {
                "use strict";
                var r = this && this.__assign || function() {
                    return r = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, r.apply(this, arguments);
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var n = function() {
                    function t(t) {
                        this.request = t, this.baseRoute = "/v3/lists";
                    }
                    return t.prototype.checkAndUpdateData = function(t) {
                        var e = r({}, t);
                        return "object" == typeof t.vars && (e.vars = JSON.stringify(e.vars)), "boolean" == typeof t.subscribed && (e.subscribed = t.subscribed ? "yes" : "no"), e;
                    }, t.prototype.listMembers = function(t, e) {
                        return this.request.get(this.baseRoute + "/" + t + "/members/pages", e).then(function(t) {
                            return t.body.items;
                        });
                    }, t.prototype.getMember = function(t, e) {
                        return this.request.get(this.baseRoute + "/" + t + "/members/" + e).then(function(t) {
                            return t.body.member;
                        });
                    }, t.prototype.createMember = function(t, e) {
                        var r = this.checkAndUpdateData(e);
                        return this.request.postWithFD(this.baseRoute + "/" + t + "/members", r).then(function(t) {
                            return t.body.member;
                        });
                    }, t.prototype.createMembers = function(t, e) {
                        var r = {
                            members: Array.isArray(e.members) ? JSON.stringify(e.members) : e.members,
                            upsert: e.upsert
                        };
                        return this.request.postWithFD(this.baseRoute + "/" + t + "/members.json", r).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.updateMember = function(t, e, r) {
                        var n = this.checkAndUpdateData(r);
                        return this.request.putWithFD(this.baseRoute + "/" + t + "/members/" + e, n).then(function(t) {
                            return t.body.member;
                        });
                    }, t.prototype.destroyMember = function(t, e) {
                        return this.request.delete(this.baseRoute + "/" + t + "/members/" + e).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = n;
            },
            197: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype._parseResponse = function(t) {
                        return t.body ? t.body : t;
                    }, t.prototype.create = function(t, e) {
                        return e.message ? this.request.postWithFD("/v3/" + t + "/messages.mime", e).then(this._parseResponse) : this.request.postWithFD("/v3/" + t + "/messages", e).then(this._parseResponse);
                    }, t;
                }();
                e.default = r;
            },
            734: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype.list = function() {
                        return this.request.get("/v4/address/validate/bulk").then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.get = function(t) {
                        return this.request.get("/v4/address/validate/bulk/" + t).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.create = function(t, e) {
                        return this.request.postWithFD("/v4/address/validate/bulk/" + t, e).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.destroy = function(t) {
                        return this.request.delete("/v4/address/validate/bulk/" + t).then(function(t) {
                            return t;
                        });
                    }, t;
                }();
                e.default = r;
            },
            438: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__awaiter || function(t, e, r, n) {
                    return new (r || (r = Promise))(function(s, o) {
                        function i(t) {
                            try {
                                u(n.next(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function a(t) {
                            try {
                                u(n.throw(t));
                            } catch (t) {
                                o(t);
                            }
                        }
                        function u(t) {
                            var e;
                            t.done ? s(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                                t(e);
                            })).then(i, a);
                        }
                        u((n = n.apply(t, e || [])).next());
                    });
                }, o = this && this.__generator || function(t, e) {
                    var r, n, s, o, i = {
                        label: 0,
                        sent: function() {
                            if (1 & s[0]) throw s[1];
                            return s[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return o = {
                        next: a(0),
                        throw: a(1),
                        return: a(2)
                    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                        return this;
                    }), o;
                    function a(o) {
                        return function(a) {
                            return function(o) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; i;)try {
                                    if (r = 1, n && (s = 2 & o[0] ? n.return : o[0] ? n.throw || ((s = n.return) && s.call(n), 0) : n.next) && !(s = s.call(n, o[1])).done) return s;
                                    switch(n = 0, s && (o = [
                                        2 & o[0],
                                        s.value
                                    ]), o[0]){
                                        case 0:
                                        case 1:
                                            s = o;
                                            break;
                                        case 4:
                                            return i.label++, {
                                                value: o[1],
                                                done: !1
                                            };
                                        case 5:
                                            i.label++, n = o[1], o = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            o = i.ops.pop(), i.trys.pop();
                                            continue;
                                        default:
                                            if (!(s = i.trys, (s = s.length > 0 && s[s.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                i = 0;
                                                continue;
                                            }
                                            if (3 === o[0] && (!s || o[1] > s[0] && o[1] < s[3])) {
                                                i.label = o[1];
                                                break;
                                            }
                                            if (6 === o[0] && i.label < s[1]) {
                                                i.label = s[1], s = o;
                                                break;
                                            }
                                            if (s && i.label < s[2]) {
                                                i.label = s[2], i.ops.push(o);
                                                break;
                                            }
                                            s[2] && i.ops.pop(), i.trys.pop();
                                            continue;
                                    }
                                    o = e.call(t, i);
                                } catch (t) {
                                    o = [
                                        6,
                                        t
                                    ], n = 0;
                                } finally{
                                    r = s = 0;
                                }
                                if (5 & o[0]) throw o[1];
                                return {
                                    value: o[0] ? o[1] : void 0,
                                    done: !0
                                };
                            }([
                                o,
                                a
                            ]);
                        };
                    }
                }, i = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var a = i(r(501)), u = i(r(78)), h = i(r(899)), p = i(r(142)), c = function(t) {
                    return "object" == typeof t && "function" == typeof t.pipe;
                };
                function f(t) {
                    return void 0 !== t.getHeaders;
                }
                var l = function() {
                    function t(t, e) {
                        this.username = t.username, this.key = t.key, this.url = t.url, this.timeout = t.timeout, this.headers = t.headers || {}, this.FormDataConstructor = e;
                    }
                    return t.prototype.request = function(t, e, r) {
                        return s(this, void 0, void 0, function() {
                            var s, i, f, l, d, y, m, v;
                            return o(this, function(o) {
                                switch(o.label){
                                    case 0:
                                        return s = n({}, r), i = a.default.encode(this.username + ":" + this.key), f = n(n({
                                            Authorization: "Basic " + i
                                        }, this.headers), null == s ? void 0 : s.headers), null == s || delete s.headers, f["Content-Type"] || delete f["Content-Type"], l = n({}, s), (null == s ? void 0 : s.query) && Object.getOwnPropertyNames(null == s ? void 0 : s.query).length > 0 && (l.searchParams = s.query, delete l.query), [
                                            4,
                                            (0, h.default)((0, u.default)(this.url, e), n({
                                                method: t.toLocaleUpperCase(),
                                                headers: f,
                                                throwHttpErrors: !1,
                                                timeout: this.timeout
                                            }, l))
                                        ];
                                    case 1:
                                        return (null == (d = o.sent()) ? void 0 : d.ok) ? [
                                            3,
                                            6
                                        ] : (null == d ? void 0 : d.body) && c(d.body) ? [
                                            4,
                                            (b = d.body, g = [], new Promise(function(t, e) {
                                                b.on("data", function(t) {
                                                    return g.push(t);
                                                }), b.on("error", e), b.on("end", function() {
                                                    return t($affd14ba9dd8837a$require$Buffer.concat(g).toString("utf8"));
                                                });
                                            }))
                                        ] : [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        return m = o.sent(), [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            null == d ? void 0 : d.json()
                                        ];
                                    case 4:
                                        m = o.sent(), o.label = 5;
                                    case 5:
                                        throw y = m, new p.default({
                                            status: null == d ? void 0 : d.status,
                                            statusText: null == d ? void 0 : d.statusText,
                                            body: {
                                                message: y
                                            }
                                        });
                                    case 6:
                                        return v = {}, [
                                            4,
                                            null == d ? void 0 : d.json()
                                        ];
                                    case 7:
                                        return v.body = o.sent(), v.status = null == d ? void 0 : d.status, [
                                            2,
                                            v
                                        ];
                                }
                                var b, g;
                            });
                        });
                    }, t.prototype.query = function(t, e, r, s) {
                        return this.request(t, e, n({
                            query: r
                        }, s));
                    }, t.prototype.command = function(t, e, r, s) {
                        return this.request(t, e, n({
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded"
                            },
                            body: r
                        }, s));
                    }, t.prototype.get = function(t, e, r) {
                        return this.query("get", t, e, r);
                    }, t.prototype.head = function(t, e, r) {
                        return this.query("head", t, e, r);
                    }, t.prototype.options = function(t, e, r) {
                        return this.query("options", t, e, r);
                    }, t.prototype.post = function(t, e, r) {
                        return this.command("post", t, e, r);
                    }, t.prototype.postWithFD = function(t, e) {
                        if (!e) throw new Error("Please provide data object");
                        var r = this.createFormData(e);
                        return this.command("post", t, r, {
                            headers: {
                                "Content-Type": null
                            }
                        });
                    }, t.prototype.putWithFD = function(t, e) {
                        if (!e) throw new Error("Please provide data object");
                        var r = this.createFormData(e);
                        return this.command("put", t, r, {
                            headers: {
                                "Content-Type": null
                            }
                        });
                    }, t.prototype.patchWithFD = function(t, e) {
                        if (!e) throw new Error("Please provide data object");
                        var r = this.createFormData(e);
                        return this.command("patch", t, r, {
                            headers: {
                                "Content-Type": null
                            }
                        });
                    }, t.prototype.createFormData = function(t) {
                        var e = this;
                        return Object.keys(t).filter(function(e) {
                            return t[e];
                        }).reduce(function(r, n) {
                            return [
                                "attachment",
                                "inline",
                                "file"
                            ].includes(n) ? (e.addFilesToFD(n, t[n], r), r) : "message" === n ? (e.addMimeDataToFD(n, t[n], r), r) : (e.addCommonPropertyToFD(n, t[n], r), r);
                        }, new this.FormDataConstructor);
                    }, t.prototype.addMimeDataToFD = function(t, e, r) {
                        f(r) ? $affd14ba9dd8837a$require$Buffer.isBuffer(e) && r.append(t, e, {
                            filename: "MimeMessage"
                        }) : r.append(t, e, "MimeMessage");
                    }, t.prototype.addFilesToFD = function(t, e, r) {
                        var s = function(t, e, r) {
                            var s = c(e) ? e : e.data, o = function(t) {
                                if ("object" != typeof t || c(t)) return {};
                                var e = t.filename, r = t.contentType, s = t.knownLength;
                                return n(n(n({}, e ? {
                                    filename: e
                                } : {
                                    filename: "file"
                                }), r && {
                                    contentType: r
                                }), s && {
                                    knownLength: s
                                });
                            }(e);
                            f(r) ? r.append(t, s, o) : r.append(t, s, o.filename);
                        };
                        Array.isArray(e) ? e.forEach(function(e) {
                            s(t, e, r);
                        }) : s(t, e, r);
                    }, t.prototype.addCommonPropertyToFD = function(t, e, r) {
                        Array.isArray(e) ? e.forEach(function(e) {
                            r.append(t, e);
                        }) : null != e && r.append(t, e);
                    }, t.prototype.put = function(t, e, r) {
                        return this.command("put", t, e, r);
                    }, t.prototype.patch = function(t, e, r) {
                        return this.command("patch", t, e, r);
                    }, t.prototype.delete = function(t, e, r) {
                        return this.command("delete", t, e, r);
                    }, t;
                }();
                e.default = l;
            },
            277: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype.list = function(t) {
                        return this.request.get("/v3/routes", t).then(function(t) {
                            return t.body.items;
                        });
                    }, t.prototype.get = function(t) {
                        return this.request.get("/v3/routes/" + t).then(function(t) {
                            return t.body.route;
                        });
                    }, t.prototype.create = function(t) {
                        return this.request.postWithFD("/v3/routes", t).then(function(t) {
                            return t.body.route;
                        });
                    }, t.prototype.update = function(t, e) {
                        return this.request.putWithFD("/v3/routes/" + t, e).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.destroy = function(t) {
                        return this.request.delete("/v3/routes/" + t).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = r;
            },
            747: function(t, e, r) {
                "use strict";
                var n = this && this.__assign || function() {
                    return n = Object.assign || function(t) {
                        for(var e, r = 1, n = arguments.length; r < n; r++)for(var s in e = arguments[r])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
                        return t;
                    }, n.apply(this, arguments);
                }, s = this && this.__spreadArray || function(t, e, r) {
                    if (r || 2 === arguments.length) for(var n, s = 0, o = e.length; s < o; s++)!n && s in e || (n || (n = Array.prototype.slice.call(e, 0, s)), n[s] = e[s]);
                    return t.concat(n || Array.prototype.slice.call(e));
                }, o = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var i = o(r(78)), a = function(t) {
                    this.start = new Date(t.start), this.end = new Date(t.end), this.resolution = t.resolution, this.stats = t.stats.map(function(t) {
                        var e = n({}, t);
                        return e.time = new Date(t.time), e;
                    });
                }, u = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype.prepareSearchParams = function(t) {
                        var e = [];
                        return "object" == typeof t && Object.keys(t).length && (e = Object.entries(t).reduce(function(t, e) {
                            var r = e[0], n = e[1];
                            if (Array.isArray(n) && n.length) {
                                var o = n.map(function(t) {
                                    return [
                                        r,
                                        t
                                    ];
                                });
                                return s(s([], t, !0), o, !0);
                            }
                            return t.push([
                                r,
                                n
                            ]), t;
                        }, [])), e;
                    }, t.prototype._parseStats = function(t) {
                        return new a(t.body);
                    }, t.prototype.getDomain = function(t, e) {
                        var r = this.prepareSearchParams(e);
                        return this.request.get((0, i.default)("/v3", t, "stats/total"), r).then(this._parseStats);
                    }, t.prototype.getAccount = function(t) {
                        var e = this.prepareSearchParams(t);
                        return this.request.get("/v3/stats/total", e).then(this._parseStats);
                    }, t;
                }();
                e.default = u;
            },
            778: function(t, e, r) {
                "use strict";
                var n = this && this.__spreadArray || function(t, e, r) {
                    if (r || 2 === arguments.length) for(var n, s = 0, o = e.length; s < o; s++)!n && s in e || (n || (n = Array.prototype.slice.call(e, 0, s)), n[s] = e[s]);
                    return t.concat(n || Array.prototype.slice.call(e));
                }, s = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var o = s(r(575)), i = s(r(78)), a = {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }, u = function(t) {
                    this.type = "bounces", this.address = t.address, this.code = +t.code, this.error = t.error, this.created_at = new Date(t.created_at);
                }, h = function(t) {
                    this.type = "complaints", this.address = t.address, this.created_at = new Date(t.created_at);
                }, p = function(t) {
                    this.type = "unsubscribes", this.address = t.address, this.tags = t.tags, this.created_at = new Date(t.created_at);
                }, c = function(t) {
                    this.type = "whitelists", this.value = t.value, this.reason = t.reason, this.createdAt = new Date(t.createdAt);
                }, f = function() {
                    function t(t) {
                        this.request = t, this.models = {
                            bounces: u,
                            complaints: h,
                            unsubscribes: p,
                            whitelists: c
                        };
                    }
                    return t.prototype._parsePage = function(t, e) {
                        var r = o.default.parse(e, !0).query;
                        return {
                            id: t,
                            page: r.page,
                            address: r.address,
                            url: e
                        };
                    }, t.prototype._parsePageLinks = function(t) {
                        var e = this;
                        return Object.entries(t.body.paging).reduce(function(t, r) {
                            var n = r[0], s = r[1];
                            return t[n] = e._parsePage(n, s), t;
                        }, {});
                    }, t.prototype._parseList = function(t, e) {
                        var r = {};
                        return r.items = t.body.items.map(function(t) {
                            return new e(t);
                        }), r.pages = this._parsePageLinks(t), r;
                    }, t.prototype._parseItem = function(t, e) {
                        return new e(t.body);
                    }, t.prototype.createWhiteList = function(t, e) {
                        return this.request.postWithFD((0, i.default)("v3", t, "whitelists"), e, a).then(function(t) {
                            return t.body;
                        });
                    }, t.prototype.list = function(t, e, r) {
                        var n = this, s = this.models[e];
                        return this.request.get((0, i.default)("v3", t, e), r).then(function(t) {
                            return n._parseList(t, s);
                        });
                    }, t.prototype.get = function(t, e, r) {
                        var n = this, s = this.models[e];
                        return this.request.get((0, i.default)("v3", t, e, encodeURIComponent(r))).then(function(t) {
                            return n._parseItem(t, s);
                        });
                    }, t.prototype.create = function(t, e, r) {
                        var s;
                        return "whitelists" === e ? this.createWhiteList(t, r) : (s = Array.isArray(r) ? n([], r, !0) : [
                            r
                        ], this.request.post((0, i.default)("v3", t, e), JSON.stringify(s), a).then(function(t) {
                            return t.body;
                        }));
                    }, t.prototype.destroy = function(t, e, r) {
                        return this.request.delete((0, i.default)("v3", t, e, encodeURIComponent(r))).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = f, t.exports = f;
            },
            721: (t, e)=>{
                "use strict";
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var r = function() {
                    function t(t, e) {
                        this.request = t, this.multipleValidation = e;
                    }
                    return t.prototype.get = function(t) {
                        return this.request.get("/v4/address/validate", {
                            address: t
                        }).then(function(t) {
                            return t;
                        }).then(function(t) {
                            return t.body;
                        });
                    }, t;
                }();
                e.default = r;
            },
            750: function(t, e, r) {
                "use strict";
                var n = this && this.__importDefault || function(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                };
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var s = n(r(78)), o = function(t, e) {
                    this.id = t, this.url = e;
                }, i = function() {
                    function t(t) {
                        this.request = t;
                    }
                    return t.prototype._parseWebhookList = function(t) {
                        return t.body.webhooks;
                    }, t.prototype._parseWebhookWithID = function(t) {
                        return function(e) {
                            var r, n = null === (r = null == e ? void 0 : e.body) || void 0 === r ? void 0 : r.webhook, s = null == n ? void 0 : n.url;
                            return s || (s = (null == n ? void 0 : n.urls) && n.urls.length ? n.urls[0] : null), new o(t, s);
                        };
                    }, t.prototype._parseWebhookTest = function(t) {
                        return {
                            code: t.body.code,
                            message: t.body.message
                        };
                    }, t.prototype.list = function(t, e) {
                        return this.request.get((0, s.default)("/v3/domains", t, "webhooks"), e).then(this._parseWebhookList);
                    }, t.prototype.get = function(t, e) {
                        return this.request.get((0, s.default)("/v3/domains", t, "webhooks", e)).then(this._parseWebhookWithID(e));
                    }, t.prototype.create = function(t, e, r, n) {
                        return void 0 === n && (n = !1), n ? this.request.putWithFD((0, s.default)("/v3/domains", t, "webhooks", e, "test"), {
                            url: r
                        }).then(this._parseWebhookTest) : this.request.postWithFD((0, s.default)("/v3/domains", t, "webhooks"), {
                            id: e,
                            url: r
                        }).then(this._parseWebhookWithID(e));
                    }, t.prototype.update = function(t, e, r) {
                        return this.request.putWithFD((0, s.default)("/v3/domains", t, "webhooks", e), {
                            url: r
                        }).then(this._parseWebhookWithID(e));
                    }, t.prototype.destroy = function(t, e) {
                        return this.request.delete((0, s.default)("/v3/domains", t, "webhooks", e)).then(this._parseWebhookWithID(e));
                    }, t;
                }();
                e.default = i;
            },
            501: function(t, e, r) {
                var n;
                t = r.nmd(t), function(s) {
                    var o = e, i = (t && t.exports, "object" == typeof r.g && r.g);
                    i.global !== i && i.window;
                    var a = function(t) {
                        this.message = t;
                    };
                    (a.prototype = new Error).name = "InvalidCharacterError";
                    var u = function(t) {
                        throw new a(t);
                    }, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = /[\t\n\f\r ]/g, c = {
                        encode: function(t) {
                            t = String(t), /[^\0-\xFF]/.test(t) && u("The string to be encoded contains characters outside of the Latin1 range.");
                            for(var e, r, n, s, o = t.length % 3, i = "", a = -1, p = t.length - o; ++a < p;)e = t.charCodeAt(a) << 16, r = t.charCodeAt(++a) << 8, n = t.charCodeAt(++a), i += h.charAt((s = e + r + n) >> 18 & 63) + h.charAt(s >> 12 & 63) + h.charAt(s >> 6 & 63) + h.charAt(63 & s);
                            return 2 == o ? (e = t.charCodeAt(a) << 8, r = t.charCodeAt(++a), i += h.charAt((s = e + r) >> 10) + h.charAt(s >> 4 & 63) + h.charAt(s << 2 & 63) + "=") : 1 == o && (s = t.charCodeAt(a), i += h.charAt(s >> 2) + h.charAt(s << 4 & 63) + "=="), i;
                        },
                        decode: function(t) {
                            var e = (t = String(t).replace(p, "")).length;
                            e % 4 == 0 && (e = (t = t.replace(/==?$/, "")).length), (e % 4 == 1 || /[^+a-zA-Z0-9/]/.test(t)) && u("Invalid character: the string to be decoded is not correctly encoded.");
                            for(var r, n, s = 0, o = "", i = -1; ++i < e;)n = h.indexOf(t.charAt(i)), r = s % 4 ? 64 * r + n : n, s++ % 4 && (o += String.fromCharCode(255 & r >> (-2 * s & 6)));
                            return o;
                        },
                        version: "1.0.0"
                    };
                    void 0 === (n = (function() {
                        return c;
                    }).call(e, r, e, t)) || (t.exports = n);
                }();
            },
            899: (t, e, r)=>{
                "use strict";
                r.r(e), r.d(e, {
                    default: ()=>R
                });
                const n = {}, s = (t)=>"undefined" != typeof self && self && t in self ? self : "undefined" != typeof window && window && t in window ? window : void 0 !== r.g && r.g && t in r.g ? r.g : "undefined" != typeof globalThis && globalThis ? globalThis : void 0, o = [
                    "Headers",
                    "Request",
                    "Response",
                    "ReadableStream",
                    "fetch",
                    "AbortController",
                    "FormData"
                ];
                for (const t of o)Object.defineProperty(n, t, {
                    get () {
                        const e = s(t), r = e && e[t];
                        return "function" == typeof r ? r.bind(e) : r;
                    }
                });
                const i = (t)=>null !== t && "object" == typeof t, a = "function" == typeof n.AbortController, u = "function" == typeof n.ReadableStream, h = "function" == typeof n.FormData, p = (t, e)=>{
                    const r = new n.Headers(t || {}), s = e instanceof n.Headers, o = new n.Headers(e || {});
                    for (const [t, e] of o)s && "undefined" === e || void 0 === e ? r.delete(t) : r.set(t, e);
                    return r;
                }, c = (...t)=>{
                    let e = {}, r = {};
                    for (const n of t){
                        if (Array.isArray(n)) Array.isArray(e) || (e = []), e = [
                            ...e,
                            ...n
                        ];
                        else if (i(n)) {
                            for (let [t, r] of Object.entries(n))i(r) && t in e && (r = c(e[t], r)), e = {
                                ...e,
                                [t]: r
                            };
                            i(n.headers) && (r = p(r, n.headers));
                        }
                        e.headers = r;
                    }
                    return e;
                }, f = [
                    "get",
                    "post",
                    "put",
                    "patch",
                    "head",
                    "delete"
                ], l = {
                    json: "application/json",
                    text: "text/*",
                    formData: "multipart/form-data",
                    arrayBuffer: "*/*",
                    blob: "*/*"
                }, d = [
                    413,
                    429,
                    503
                ], y = Symbol("stop");
                class HTTPError extends Error {
                    constructor(t){
                        super(t.statusText || String(0 === t.status || t.status ? t.status : "Unknown response error")), this.name = "HTTPError", this.response = t;
                    }
                }
                class TimeoutError extends Error {
                    constructor(t){
                        super("Request timed out"), this.name = "TimeoutError", this.request = t;
                    }
                }
                const m = (t)=>new Promise((e)=>setTimeout(e, t)), v = (t)=>f.includes(t) ? t.toUpperCase() : t, b = {
                    limit: 2,
                    methods: [
                        "get",
                        "put",
                        "head",
                        "delete",
                        "options",
                        "trace"
                    ],
                    statusCodes: [
                        408,
                        413,
                        429,
                        500,
                        502,
                        503,
                        504
                    ],
                    afterStatusCodes: d
                }, g = (t = {})=>{
                    if ("number" == typeof t) return {
                        ...b,
                        limit: t
                    };
                    if (t.methods && !Array.isArray(t.methods)) throw new Error("retry.methods must be an array");
                    if (t.statusCodes && !Array.isArray(t.statusCodes)) throw new Error("retry.statusCodes must be an array");
                    return {
                        ...b,
                        ...t,
                        afterStatusCodes: d
                    };
                }, _ = 2147483647;
                class Ky {
                    constructor(t, e = {}){
                        if (this._retryCount = 0, this._input = t, this._options = {
                            credentials: this._input.credentials || "same-origin",
                            ...e,
                            headers: p(this._input.headers, e.headers),
                            hooks: c({
                                beforeRequest: [],
                                beforeRetry: [],
                                afterResponse: []
                            }, e.hooks),
                            method: v(e.method || this._input.method),
                            prefixUrl: String(e.prefixUrl || ""),
                            retry: g(e.retry),
                            throwHttpErrors: !1 !== e.throwHttpErrors,
                            timeout: void 0 === e.timeout ? 1e4 : e.timeout,
                            fetch: e.fetch || n.fetch
                        }, "string" != typeof this._input && !(this._input instanceof URL || this._input instanceof n.Request)) throw new TypeError("`input` must be a string, URL, or Request");
                        if (this._options.prefixUrl && "string" == typeof this._input) {
                            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
                            this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
                        }
                        if (a && (this.abortController = new n.AbortController, this._options.signal && this._options.signal.addEventListener("abort", ()=>{
                            this.abortController.abort();
                        }), this._options.signal = this.abortController.signal), this.request = new n.Request(this._input, this._options), this._options.searchParams) {
                            const t = "?" + new URLSearchParams(this._options.searchParams).toString(), e = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, t);
                            !(h && this._options.body instanceof n.FormData || this._options.body instanceof URLSearchParams) || this._options.headers && this._options.headers["content-type"] || this.request.headers.delete("content-type"), this.request = new n.Request(new n.Request(e, this.request), this._options);
                        }
                        void 0 !== this._options.json && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", "application/json"), this.request = new n.Request(this.request, {
                            body: this._options.body
                        }));
                        const r = async ()=>{
                            if (this._options.timeout > _) throw new RangeError("The `timeout` option cannot be greater than 2147483647");
                            await m(1);
                            let t = await this._fetch();
                            for (const e of this._options.hooks.afterResponse){
                                const r = await e(this.request, this._options, this._decorateResponse(t.clone()));
                                r instanceof n.Response && (t = r);
                            }
                            if (this._decorateResponse(t), !t.ok && this._options.throwHttpErrors) throw new HTTPError(t);
                            if (this._options.onDownloadProgress) {
                                if ("function" != typeof this._options.onDownloadProgress) throw new TypeError("The `onDownloadProgress` option must be a function");
                                if (!u) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                                return this._stream(t.clone(), this._options.onDownloadProgress);
                            }
                            return t;
                        }, s = this._options.retry.methods.includes(this.request.method.toLowerCase()) ? this._retry(r) : r();
                        for (const [t, r] of Object.entries(l))s[t] = async ()=>{
                            this.request.headers.set("accept", this.request.headers.get("accept") || r);
                            const n = (await s).clone();
                            if ("json" === t) {
                                if (204 === n.status) return "";
                                if (e.parseJson) return e.parseJson(await n.text());
                            }
                            return n[t]();
                        };
                        return s;
                    }
                    _calculateRetryDelay(t) {
                        if (this._retryCount++, this._retryCount < this._options.retry.limit && !(t instanceof TimeoutError)) {
                            if (t instanceof HTTPError) {
                                if (!this._options.retry.statusCodes.includes(t.response.status)) return 0;
                                const e = t.response.headers.get("Retry-After");
                                if (e && this._options.retry.afterStatusCodes.includes(t.response.status)) {
                                    let t = Number(e);
                                    return Number.isNaN(t) ? t = Date.parse(e) - Date.now() : t *= 1e3, void 0 !== this._options.retry.maxRetryAfter && t > this._options.retry.maxRetryAfter ? 0 : t;
                                }
                                if (413 === t.response.status) return 0;
                            }
                            return .3 * 2 ** (this._retryCount - 1) * 1e3;
                        }
                        return 0;
                    }
                    _decorateResponse(t) {
                        return this._options.parseJson && (t.json = async ()=>this._options.parseJson(await t.text())), t;
                    }
                    async _retry(t) {
                        try {
                            return await t();
                        } catch (e) {
                            const r = Math.min(this._calculateRetryDelay(e), _);
                            if (0 !== r && this._retryCount > 0) {
                                await m(r);
                                for (const t of this._options.hooks.beforeRetry){
                                    if (await t({
                                        request: this.request,
                                        options: this._options,
                                        error: e,
                                        retryCount: this._retryCount
                                    }) === y) return;
                                }
                                return this._retry(t);
                            }
                            if (this._options.throwHttpErrors) throw e;
                        }
                    }
                    async _fetch() {
                        for (const t of this._options.hooks.beforeRequest){
                            const e = await t(this.request, this._options);
                            if (e instanceof Request) {
                                this.request = e;
                                break;
                            }
                            if (e instanceof Response) return e;
                        }
                        var t, e, r;
                        return !1 === this._options.timeout ? this._options.fetch(this.request.clone()) : (t = this.request.clone(), e = this.abortController, r = this._options, new Promise((n, s)=>{
                            const o = setTimeout(()=>{
                                e && e.abort(), s(new TimeoutError(t));
                            }, r.timeout);
                            r.fetch(t).then(n).catch(s).then(()=>{
                                clearTimeout(o);
                            });
                        }));
                    }
                    _stream(t, e) {
                        const r = Number(t.headers.get("content-length")) || 0;
                        let s = 0;
                        return new n.Response(new n.ReadableStream({
                            start (n) {
                                const o = t.body.getReader();
                                e && e({
                                    percent: 0,
                                    transferredBytes: 0,
                                    totalBytes: r
                                }, new Uint8Array), async function t() {
                                    const { done: i, value: a } = await o.read();
                                    if (i) n.close();
                                    else {
                                        if (e) {
                                            s += a.byteLength;
                                            e({
                                                percent: 0 === r ? 0 : s / r,
                                                transferredBytes: s,
                                                totalBytes: r
                                            }, a);
                                        }
                                        n.enqueue(a), t();
                                    }
                                }();
                            }
                        }));
                    }
                }
                const w = (...t)=>{
                    for (const e of t)if ((!i(e) || Array.isArray(e)) && void 0 !== e) throw new TypeError("The `options` argument must be an object");
                    return c({}, ...t);
                }, q = (t)=>{
                    const e = (e, r)=>new Ky(e, w(t, r));
                    for (const r of f)e[r] = (e, n)=>new Ky(e, w(t, n, {
                            method: r
                        }));
                    return e.HTTPError = HTTPError, e.TimeoutError = TimeoutError, e.create = (t)=>q(w(t)), e.extend = (e)=>q(w(t, e)), e.stop = y, e;
                }, R = q();
            },
            971: function(t, e, r) {
                var n;
                t = r.nmd(t), function(s) {
                    e && e.nodeType, t && t.nodeType;
                    var o = "object" == typeof r.g && r.g;
                    o.global !== o && o.window !== o && o.self;
                    var i, a = 2147483647, u = 36, h = /^xn--/, p = /[^\x20-\x7E]/, c = /[\x2E\u3002\uFF0E\uFF61]/g, f = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, l = Math.floor, d = String.fromCharCode;
                    function y(t) {
                        throw RangeError(f[t]);
                    }
                    function m(t, e) {
                        for(var r = t.length, n = []; r--;)n[r] = e(t[r]);
                        return n;
                    }
                    function v(t, e) {
                        var r = t.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", t = r[1]), n + m((t = t.replace(c, ".")).split("."), e).join(".");
                    }
                    function b(t) {
                        for(var e, r, n = [], s = 0, o = t.length; s < o;)(e = t.charCodeAt(s++)) >= 55296 && e <= 56319 && s < o ? 56320 == (64512 & (r = t.charCodeAt(s++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), s--) : n.push(e);
                        return n;
                    }
                    function g(t) {
                        return m(t, function(t) {
                            var e = "";
                            return t > 65535 && (e += d((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += d(t);
                        }).join("");
                    }
                    function _(t, e) {
                        return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                    }
                    function w(t, e, r) {
                        var n = 0;
                        for(t = r ? l(t / 700) : t >> 1, t += l(t / e); t > 455; n += u)t = l(t / 35);
                        return l(n + 36 * t / (t + 38));
                    }
                    function q(t) {
                        var e, r, n, s, o, i, h, p, c, f, d, m = [], v = t.length, b = 0, _ = 128, q = 72;
                        for((r = t.lastIndexOf("-")) < 0 && (r = 0), n = 0; n < r; ++n)t.charCodeAt(n) >= 128 && y("not-basic"), m.push(t.charCodeAt(n));
                        for(s = r > 0 ? r + 1 : 0; s < v;){
                            for(o = b, i = 1, h = u; s >= v && y("invalid-input"), ((p = (d = t.charCodeAt(s++)) - 48 < 10 ? d - 22 : d - 65 < 26 ? d - 65 : d - 97 < 26 ? d - 97 : u) >= u || p > l((a - b) / i)) && y("overflow"), b += p * i, !(p < (c = h <= q ? 1 : h >= q + 26 ? 26 : h - q)); h += u)i > l(a / (f = u - c)) && y("overflow"), i *= f;
                            q = w(b - o, e = m.length + 1, 0 == o), l(b / e) > a - _ && y("overflow"), _ += l(b / e), b %= e, m.splice(b++, 0, _);
                        }
                        return g(m);
                    }
                    function R(t) {
                        var e, r, n, s, o, i, h, p, c, f, m, v, g, q, R, D = [];
                        for(v = (t = b(t)).length, e = 128, r = 0, o = 72, i = 0; i < v; ++i)(m = t[i]) < 128 && D.push(d(m));
                        for(n = s = D.length, s && D.push("-"); n < v;){
                            for(h = a, i = 0; i < v; ++i)(m = t[i]) >= e && m < h && (h = m);
                            for(h - e > l((a - r) / (g = n + 1)) && y("overflow"), r += (h - e) * g, e = h, i = 0; i < v; ++i)if ((m = t[i]) < e && ++r > a && y("overflow"), m == e) {
                                for(p = r, c = u; !(p < (f = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += u)R = p - f, q = u - f, D.push(d(_(f + R % q, 0))), p = l(R / q);
                                D.push(d(_(p, 0))), o = w(r, g, n == s), r = 0, ++n;
                            }
                            ++r, ++e;
                        }
                        return D.join("");
                    }
                    i = {
                        version: "1.3.2",
                        ucs2: {
                            decode: b,
                            encode: g
                        },
                        decode: q,
                        encode: R,
                        toASCII: function(t) {
                            return v(t, function(t) {
                                return p.test(t) ? "xn--" + R(t) : t;
                            });
                        },
                        toUnicode: function(t) {
                            return v(t, function(t) {
                                return h.test(t) ? q(t.slice(4).toLowerCase()) : t;
                            });
                        }
                    }, void 0 === (n = (function() {
                        return i;
                    }).call(e, r, e, t)) || (t.exports = n);
                }();
            },
            587: (t)=>{
                "use strict";
                function e(t, e) {
                    return Object.prototype.hasOwnProperty.call(t, e);
                }
                t.exports = function(t, r, n, s) {
                    r = r || "&", n = n || "=";
                    var o = {};
                    if ("string" != typeof t || 0 === t.length) return o;
                    var i = /\+/g;
                    t = t.split(r);
                    var a = 1e3;
                    s && "number" == typeof s.maxKeys && (a = s.maxKeys);
                    var u = t.length;
                    a > 0 && u > a && (u = a);
                    for(var h = 0; h < u; ++h){
                        var p, c, f, l, d = t[h].replace(i, "%20"), y = d.indexOf(n);
                        y >= 0 ? (p = d.substr(0, y), c = d.substr(y + 1)) : (p = d, c = ""), f = decodeURIComponent(p), l = decodeURIComponent(c), e(o, f) ? Array.isArray(o[f]) ? o[f].push(l) : o[f] = [
                            o[f],
                            l
                        ] : o[f] = l;
                    }
                    return o;
                };
            },
            361: (t)=>{
                "use strict";
                var e = function(t) {
                    switch(typeof t){
                        case "string":
                            return t;
                        case "boolean":
                            return t ? "true" : "false";
                        case "number":
                            return isFinite(t) ? t : "";
                        default:
                            return "";
                    }
                };
                t.exports = function(t, r, n, s) {
                    return r = r || "&", n = n || "=", null === t && (t = void 0), "object" == typeof t ? Object.keys(t).map(function(s) {
                        var o = encodeURIComponent(e(s)) + n;
                        return Array.isArray(t[s]) ? t[s].map(function(t) {
                            return o + encodeURIComponent(e(t));
                        }).join(r) : o + encodeURIComponent(e(t[s]));
                    }).join(r) : s ? encodeURIComponent(e(s)) + n + encodeURIComponent(e(t)) : "";
                };
            },
            673: (t, e, r)=>{
                "use strict";
                e.decode = e.parse = r(587), e.encode = e.stringify = r(361);
            },
            78: (t)=>{
                function e(t) {
                    return t.replace(/[\/]+/g, "/").replace(/\/\?/g, "?").replace(/\/\#/g, "#").replace(/\:\//g, "://");
                }
                t.exports = function() {
                    var t = [].slice.call(arguments, 0).join("/");
                    return e(t);
                };
            },
            575: (t, e, r)=>{
                "use strict";
                var n = r(971), s = r(502);
                function o() {
                    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
                }
                e.parse = g, e.resolve = function(t, e) {
                    return g(t, !1, !0).resolve(e);
                }, e.resolveObject = function(t, e) {
                    return t ? g(t, !1, !0).resolveObject(e) : e;
                }, e.format = function(t) {
                    s.isString(t) && (t = g(t));
                    return t instanceof o ? t.format() : o.prototype.format.call(t);
                }, e.Url = o;
                var i = /^([a-z0-9.+-]+:)/i, a = /:[0-9]*$/, u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, h = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat([
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "\t"
                ]), p = [
                    "'"
                ].concat(h), c = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(p), f = [
                    "/",
                    "?",
                    "#"
                ], l = /^[+a-z0-9A-Z_-]{0,63}$/, d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, y = {
                    javascript: !0,
                    "javascript:": !0
                }, m = {
                    javascript: !0,
                    "javascript:": !0
                }, v = {
                    http: !0,
                    https: !0,
                    ftp: !0,
                    gopher: !0,
                    file: !0,
                    "http:": !0,
                    "https:": !0,
                    "ftp:": !0,
                    "gopher:": !0,
                    "file:": !0
                }, b = r(673);
                function g(t, e, r) {
                    if (t && s.isObject(t) && t instanceof o) return t;
                    var n = new o;
                    return n.parse(t, e, r), n;
                }
                o.prototype.parse = function(t, e, r) {
                    if (!s.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
                    var o = t.indexOf("?"), a = -1 !== o && o < t.indexOf("#") ? "?" : "#", h = t.split(a);
                    h[0] = h[0].replace(/\\/g, "/");
                    var g = t = h.join(a);
                    if (g = g.trim(), !r && 1 === t.split("#").length) {
                        var _ = u.exec(g);
                        if (_) return this.path = g, this.href = g, this.pathname = _[1], _[2] ? (this.search = _[2], this.query = e ? b.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
                    }
                    var w = i.exec(g);
                    if (w) {
                        var q = (w = w[0]).toLowerCase();
                        this.protocol = q, g = g.substr(w.length);
                    }
                    if (r || w || g.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                        var R = "//" === g.substr(0, 2);
                        !R || w && m[w] || (g = g.substr(2), this.slashes = !0);
                    }
                    if (!m[w] && (R || w && !v[w])) {
                        for(var D, j, O = -1, A = 0; A < f.length; A++)-1 !== (P = g.indexOf(f[A])) && (-1 === O || P < O) && (O = P);
                        -1 !== (j = -1 === O ? g.lastIndexOf("@") : g.lastIndexOf("@", O)) && (D = g.slice(0, j), g = g.slice(j + 1), this.auth = decodeURIComponent(D)), O = -1;
                        for(A = 0; A < c.length; A++){
                            var P;
                            -1 !== (P = g.indexOf(c[A])) && (-1 === O || P < O) && (O = P);
                        }
                        -1 === O && (O = g.length), this.host = g.slice(0, O), g = g.slice(O), this.parseHost(), this.hostname = this.hostname || "";
                        var T = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                        if (!T) for(var C = this.hostname.split(/\./), k = (A = 0, C.length); A < k; A++){
                            var x = C[A];
                            if (x && !x.match(l)) {
                                for(var M = "", F = 0, S = x.length; F < S; F++)x.charCodeAt(F) > 127 ? M += "x" : M += x[F];
                                if (!M.match(l)) {
                                    var W = C.slice(0, A), E = C.slice(A + 1), I = x.match(d);
                                    I && (W.push(I[1]), E.unshift(I[2])), E.length && (g = "/" + E.join(".") + g), this.hostname = W.join(".");
                                    break;
                                }
                            }
                        }
                        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), T || (this.hostname = n.toASCII(this.hostname));
                        var L = this.port ? ":" + this.port : "", U = this.hostname || "";
                        this.host = U + L, this.href += this.host, T && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== g[0] && (g = "/" + g));
                    }
                    if (!y[q]) for(A = 0, k = p.length; A < k; A++){
                        var N = p[A];
                        if (-1 !== g.indexOf(N)) {
                            var H = encodeURIComponent(N);
                            H === N && (H = escape(N)), g = g.split(N).join(H);
                        }
                    }
                    var V = g.indexOf("#");
                    -1 !== V && (this.hash = g.substr(V), g = g.slice(0, V));
                    var B = g.indexOf("?");
                    if (-1 !== B ? (this.search = g.substr(B), this.query = g.substr(B + 1), e && (this.query = b.parse(this.query)), g = g.slice(0, B)) : e && (this.search = "", this.query = {}), g && (this.pathname = g), v[q] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                        L = this.pathname || "";
                        var J = this.search || "";
                        this.path = L + J;
                    }
                    return this.href = this.format(), this;
                }, o.prototype.format = function() {
                    var t = this.auth || "";
                    t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
                    var e = this.protocol || "", r = this.pathname || "", n = this.hash || "", o = !1, i = "";
                    this.host ? o = t + this.host : this.hostname && (o = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && s.isObject(this.query) && Object.keys(this.query).length && (i = b.stringify(this.query));
                    var a = this.search || i && "?" + i || "";
                    return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || v[e]) && !1 !== o ? (o = "//" + (o || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : o || (o = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + o + (r = r.replace(/[?#]/g, function(t) {
                        return encodeURIComponent(t);
                    })) + (a = a.replace("#", "%23")) + n;
                }, o.prototype.resolve = function(t) {
                    return this.resolveObject(g(t, !1, !0)).format();
                }, o.prototype.resolveObject = function(t) {
                    if (s.isString(t)) {
                        var e = new o;
                        e.parse(t, !1, !0), t = e;
                    }
                    for(var r = new o, n = Object.keys(this), i = 0; i < n.length; i++){
                        var a = n[i];
                        r[a] = this[a];
                    }
                    if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;
                    if (t.slashes && !t.protocol) {
                        for(var u = Object.keys(t), h = 0; h < u.length; h++){
                            var p = u[h];
                            "protocol" !== p && (r[p] = t[p]);
                        }
                        return v[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
                    }
                    if (t.protocol && t.protocol !== r.protocol) {
                        if (!v[t.protocol]) {
                            for(var c = Object.keys(t), f = 0; f < c.length; f++){
                                var l = c[f];
                                r[l] = t[l];
                            }
                            return r.href = r.format(), r;
                        }
                        if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;
                        else {
                            for(var d = (t.pathname || "").split("/"); d.length && !(t.host = d.shift()););
                            t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), r.pathname = d.join("/");
                        }
                        if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
                            var y = r.pathname || "", b = r.search || "";
                            r.path = y + b;
                        }
                        return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                    }
                    var g = r.pathname && "/" === r.pathname.charAt(0), _ = t.host || t.pathname && "/" === t.pathname.charAt(0), w = _ || g || r.host && t.pathname, q = w, R = r.pathname && r.pathname.split("/") || [], D = (d = t.pathname && t.pathname.split("/") || [], r.protocol && !v[r.protocol]);
                    if (D && (r.hostname = "", r.port = null, r.host && ("" === R[0] ? R[0] = r.host : R.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === d[0] ? d[0] = t.host : d.unshift(t.host)), t.host = null), w = w && ("" === d[0] || "" === R[0])), _) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, R = d;
                    else if (d.length) R || (R = []), R.pop(), R = R.concat(d), r.search = t.search, r.query = t.query;
                    else if (!s.isNullOrUndefined(t.search)) {
                        if (D) r.hostname = r.host = R.shift(), (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift());
                        return r.search = t.search, r.query = t.query, s.isNull(r.pathname) && s.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                    }
                    if (!R.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                    for(var j = R.slice(-1)[0], O = (r.host || t.host || R.length > 1) && ("." === j || ".." === j) || "" === j, A = 0, P = R.length; P >= 0; P--)"." === (j = R[P]) ? R.splice(P, 1) : ".." === j ? (R.splice(P, 1), A++) : A && (R.splice(P, 1), A--);
                    if (!w && !q) for(; A--; A)R.unshift("..");
                    !w || "" === R[0] || R[0] && "/" === R[0].charAt(0) || R.unshift(""), O && "/" !== R.join("/").substr(-1) && R.push("");
                    var T, C = "" === R[0] || R[0] && "/" === R[0].charAt(0);
                    D && (r.hostname = r.host = C ? "" : R.length ? R.shift() : "", (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift()));
                    return (w = w || r.host && R.length) && !C && R.unshift(""), R.length ? r.pathname = R.join("/") : (r.pathname = null, r.path = null), s.isNull(r.pathname) && s.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
                }, o.prototype.parseHost = function() {
                    var t = this.host, e = a.exec(t);
                    e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
                };
            },
            502: (t)=>{
                "use strict";
                t.exports = {
                    isString: function(t) {
                        return "string" == typeof t;
                    },
                    isObject: function(t) {
                        return "object" == typeof t && null !== t;
                    },
                    isNull: function(t) {
                        return null === t;
                    },
                    isNullOrUndefined: function(t) {
                        return null == t;
                    }
                };
            }
        }, e = {};
        function r(n) {
            var s = e[n];
            if (void 0 !== s) return s.exports;
            var o = e[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
        }
        return r.d = (t, e)=>{
            for(var n in e)r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), r.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.nmd = (t)=>(t.paths = [], t.children || (t.children = []), t), r(48);
    })();
});


const $91310346c791545d$var$mailgun = new $affd14ba9dd8837a$exports($7643641a377e4c74$exports);
async function $91310346c791545d$var$sendVerseToEmail(toEmail, verse, hasSubscribed) {
    const removeHTMLTags = function(text) {
        return text.replace(/<\/?[^>]+(>|$)/g, "");
    };
    const DOMAIN = 'mg1.mpen-international.com';
    const api_key = '';
    const mg = $91310346c791545d$var$mailgun.client({
        username: 'api',
        key: "ec1ef954d81570498a76265154a76b00-e61ae8dd-82ad7624",
        public_key: 'pubkey-b373d88ece2f713bf201c9412488cb33'
    });
    const verseFR = removeHTMLTags(verse.verseFR);
    const verseEN = removeHTMLTags(verse.verseEN);
    const year = "2026";
    const wishesFR = "Bonne ann\xe9e " + year;
    const wishesEN = "Happy new year " + year;
    const yourVerseFRDescription = "Ton verset de l'ann\xe9e " + year;
    const yourVerseENDescription = "Here is Your verse of the year " + year;
    const data = {
        from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
        to: `${toEmail}`,
        subject: `Your verse of the year ${year} | Ton verset de l'ann\xe9e ${year} `,
        template: 'verseoftheyear',
        'h:X-Mailgun-Variables': `{"verseFR": "${verseFR}", "verseEN": "${verseEN}", "wishesFR": "${wishesFR}", "wishesEN": "${wishesEN}", "yourVerseFRDescription": "${yourVerseFRDescription}", "yourVerseENDescription": "${yourVerseENDescription}"}`
    };
    await mg.messages.create(DOMAIN, data);
    //Adding subscribed email to mailchimp
    console.log('has subscribed ' + hasSubscribed);
    if (hasSubscribed === true) {
        //Fast solution
        const dataSubscribed = {
            from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
            to: `mpensubscriptions@gmail.com`,
            subject: `New Subscription Throught Verse Of the Year`,
            text: toEmail
        };
        mg.messages.create(DOMAIN, dataSubscribed).then((msg)=>console.log(msg)).catch((err)=>console.log(err));
    }
}
async function $91310346c791545d$var$sendVerseToEmailSimple(toEmail, verse, hasSubscribed) {
    const DOMAIN = 'mg1.mpen-international.com';
    const api_key = '';
    const mg = $91310346c791545d$var$mailgun.client({
        username: 'api',
        key: "ec1ef954d81570498a76265154a76b00-e61ae8dd-82ad7624",
        public_key: 'pubkey-b373d88ece2f713bf201c9412488cb33'
    });
    const year = "2026";
    const wishesFR = "Bonne ann\xe9e " + year;
    const wishesEN = "Happy new year " + year;
    const yourVerseFRDescription = "Ton verset de l'ann\xe9e " + year;
    const yourVerseENDescription = "Your verse of the year " + year;
    // Build styled HTML email
    const htmlBody = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
        }
        .header {
            text-align: center;
            padding: 20px 0;
            border-bottom: 3px solid #022a4b;
            margin-bottom: 30px;
        }
        .header h1 {
            color: #022a4b;
            margin: 0;
        }
        .section {
            margin: 30px 0;
            padding: 20px;
            background-color: #f9f9f9;
            border-left: 4px solid #022a4b;
        }
        .section h2 {
            color: #022a4b;
            margin-top: 0;
        }
        .verse {
            font-size: 16px;
            line-height: 1.8;
            color: #555;
        }
        .footer {
            text-align: center;
            margin-top: 40px;
            padding-top: 20px;
            border-top: 1px solid #ddd;
            color: #888;
            font-size: 12px;
        }
    </style>
</head>
<body>
    <div class="header">
        <h1>${wishesEN} / ${wishesFR}</h1>
    </div>

    <div class="section">
        <h2>${yourVerseENDescription}</h2>
        <div class="verse">
            ${verse.verseEN}
        </div>
    </div>

    <div class="section">
        <h2>${yourVerseFRDescription}</h2>
        <div class="verse">
            ${verse.verseFR}
        </div>
    </div>

    <div class="footer">
        <p>MPEN International - Verses of the Year ${year}</p>
    </div>
</body>
</html>
    `;
    // Send email with HTML body (no template)
    const data = {
        from: 'Verses MPEN-INTERNATIONAL <versets@mg1.mpen-international.com>',
        to: `${toEmail}`,
        subject: `Your verse of the year ${year} | Ton verset de l'ann\xe9e ${year}`,
        html: htmlBody
    };
    await mg.messages.create(DOMAIN, data);
    console.log('Simple email sent to ' + toEmail);
    // Adding subscribed email to mailchimp
    console.log('has subscribed ' + hasSubscribed);
    if (hasSubscribed === true) {
        const dataSubscribed = {
            from: 'Verses MPEN-INTERNATIONAL <contact@mpen-international.com>',
            to: `mpensubscriptions@gmail.com`,
            subject: `New Subscription Through Verse Of the Year`,
            text: toEmail
        };
        mg.messages.create(DOMAIN, dataSubscribed).then((msg)=>console.log(msg)).catch((err)=>console.log(err));
    }
}
$91310346c791545d$exports = {
    sendVerseToEmail: $91310346c791545d$var$sendVerseToEmail,
    sendVerseToEmailSimple: $91310346c791545d$var$sendVerseToEmailSimple
};


async function $2f2ecaadeeadd453$export$b981489921ee18cd() {
    const regexEmailValidation = /\S+@\S+\.\S+/;
    const email = (0, $f9da35ca885f15a0$export$19732eed08316548).value;
    const checkbox = document.querySelector("#check_newsletters").checked;
    if (email && regexEmailValidation.test(email)) {
        (0, $f9da35ca885f15a0$export$19732eed08316548).classList.remove('error');
        (0, $f9da35ca885f15a0$export$e317c825d4537eb2).style.visibility = "hidden";
        const verse = (0, $71b08f0ec20f8cf3$export$19e5ffab0d0b9126)((0, $56f685a6bdc4117b$export$2e2bcd8739ae039), (0, $f9da35ca885f15a0$export$c61c2cc86422adfb).textContent);
        console.log(verse);
        (0, $f9da35ca885f15a0$export$32e8bae6af6667e9).textContent = verse.verseFR + verse.verseEN;
        (0, $f9da35ca885f15a0$export$c61c2cc86422adfb).innerHTML += '<div class="verse-fr">' + verse.verseFR + '</div><br><div class="verse-fr">' + verse.verseEN + '</div>';
        document.querySelector(".verse-form").style.display = 'none';
        document.querySelector(".verse").style.display = "block";
        console.log("Verse from handler" + verse.verseFR);
        await (0, $91310346c791545d$exports.sendVerseToEmailSimple)(email, verse, checkbox);
    } else {
        document.querySelector(".verse-form").style.display = 'block';
        document.querySelector(".verse").display = "none";
        (0, $f9da35ca885f15a0$export$19732eed08316548).classList.add('error');
        (0, $f9da35ca885f15a0$export$e317c825d4537eb2).style.visibility = "visible";
    }
} // export async function handleClick() {
 //   hiddenVerseHolder.textContent = getRandomVerse(
 //       versesBucket,
 //       verseHolder.textContent
 //   ).item;
 //   document.querySelector(".getVerse").style.visibility = "hidden";
 //
 // }



(0, $f9da35ca885f15a0$export$19732eed08316548).addEventListener('keydown', ()=>{
    (0, $f9da35ca885f15a0$export$19732eed08316548).classList.remove('error');
    (0, $f9da35ca885f15a0$export$e317c825d4537eb2).style.visibility = "hidden";
});
(0, $f9da35ca885f15a0$export$9655df7bb03b83fe).addEventListener('click', (0, $2f2ecaadeeadd453$export$b981489921ee18cd));


//# sourceMappingURL=path0.17bbdaec.js.map
